import { getDefaultExportFromCjs as Ir, commonjsGlobal as Qu } from "./ghl-ui.es436.js";
import { __module as Yu } from "./ghl-ui.es438.js";
(function(Ju, $r) {
  (function(P) {
    Ju.exports = P();
  })(function() {
    var P = (N, c) => () => (c || N((c = { exports: {} }).exports, c), c.exports), ve = P((N, c) => {
      var l = function(d) {
        return d && d.Math == Math && d;
      };
      c.exports = l(typeof globalThis == "object" && globalThis) || l(typeof window == "object" && window) || l(typeof self == "object" && self) || l(typeof Qu == "object" && Qu) || function() {
        return this;
      }() || Function("return this")();
    }), ye = P((N, c) => {
      c.exports = function(l) {
        try {
          return !!l();
        } catch {
          return !0;
        }
      };
    }), we = P((N, c) => {
      var l = ye();
      c.exports = !l(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }), eu = P((N, c) => {
      var l = ye();
      c.exports = !l(function() {
        var d = (function() {
        }).bind();
        return typeof d != "function" || d.hasOwnProperty("prototype");
      });
    }), Oe = P((N, c) => {
      var l = eu(), d = Function.prototype.call;
      c.exports = l ? d.bind(d) : function() {
        return d.apply(d, arguments);
      };
    }), Ku = P((N) => {
      var c = {}.propertyIsEnumerable, l = Object.getOwnPropertyDescriptor, d = l && !c.call({ 1: 2 }, 1);
      N.f = d ? function(h) {
        var g = l(this, h);
        return !!g && g.enumerable;
      } : c;
    }), uu = P((N, c) => {
      c.exports = function(l, d) {
        return { enumerable: !(l & 1), configurable: !(l & 2), writable: !(l & 4), value: d };
      };
    }), Te = P((N, c) => {
      var l = eu(), d = Function.prototype, h = d.call, g = l && d.bind.bind(h, h);
      c.exports = l ? g : function(_) {
        return function() {
          return h.apply(_, arguments);
        };
      };
    }), Ue = P((N, c) => {
      var l = Te(), d = l({}.toString), h = l("".slice);
      c.exports = function(g) {
        return h(d(g), 8, -1);
      };
    }), Zu = P((N, c) => {
      var l = Te(), d = ye(), h = Ue(), g = Object, _ = l("".split);
      c.exports = d(function() {
        return !g("z").propertyIsEnumerable(0);
      }) ? function(w) {
        return h(w) == "String" ? _(w, "") : g(w);
      } : g;
    }), tu = P((N, c) => {
      c.exports = function(l) {
        return l == null;
      };
    }), hu = P((N, c) => {
      var l = tu(), d = TypeError;
      c.exports = function(h) {
        if (l(h))
          throw d("Can't call method on " + h);
        return h;
      };
    }), ru = P((N, c) => {
      var l = Zu(), d = hu();
      c.exports = function(h) {
        return l(d(h));
      };
    }), du = P((N, c) => {
      var l = typeof document == "object" && document.all, d = typeof l > "u" && l !== void 0;
      c.exports = { all: l, IS_HTMLDDA: d };
    }), Ee = P((N, c) => {
      var l = du(), d = l.all;
      c.exports = l.IS_HTMLDDA ? function(h) {
        return typeof h == "function" || h === d;
      } : function(h) {
        return typeof h == "function";
      };
    }), Pe = P((N, c) => {
      var l = Ee(), d = du(), h = d.all;
      c.exports = d.IS_HTMLDDA ? function(g) {
        return typeof g == "object" ? g !== null : l(g) || g === h;
      } : function(g) {
        return typeof g == "object" ? g !== null : l(g);
      };
    }), Ve = P((N, c) => {
      var l = ve(), d = Ee(), h = function(g) {
        return d(g) ? g : void 0;
      };
      c.exports = function(g, _) {
        return arguments.length < 2 ? h(l[g]) : l[g] && l[g][_];
      };
    }), Cu = P((N, c) => {
      var l = Te();
      c.exports = l({}.isPrototypeOf);
    }), et = P((N, c) => {
      var l = Ve();
      c.exports = l("navigator", "userAgent") || "";
    }), ut = P((N, c) => {
      var l = ve(), d = et(), h = l.process, g = l.Deno, _ = h && h.versions || g && g.version, w = _ && _.v8, y, x;
      w && (y = w.split("."), x = y[0] > 0 && y[0] < 4 ? 1 : +(y[0] + y[1])), !x && d && (y = d.match(/Edge\/(\d+)/), (!y || y[1] >= 74) && (y = d.match(/Chrome\/(\d+)/), y && (x = +y[1]))), c.exports = x;
    }), Eu = P((N, c) => {
      var l = ut(), d = ye();
      c.exports = !!Object.getOwnPropertySymbols && !d(function() {
        var h = Symbol();
        return !String(h) || !(Object(h) instanceof Symbol) || !Symbol.sham && l && l < 41;
      });
    }), mu = P((N, c) => {
      var l = Eu();
      c.exports = l && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }), fu = P((N, c) => {
      var l = Ve(), d = Ee(), h = Cu(), g = mu(), _ = Object;
      c.exports = g ? function(w) {
        return typeof w == "symbol";
      } : function(w) {
        var y = l("Symbol");
        return d(y) && h(y.prototype, _(w));
      };
    }), nu = P((N, c) => {
      var l = String;
      c.exports = function(d) {
        try {
          return l(d);
        } catch {
          return "Object";
        }
      };
    }), Ge = P((N, c) => {
      var l = Ee(), d = nu(), h = TypeError;
      c.exports = function(g) {
        if (l(g))
          return g;
        throw h(d(g) + " is not a function");
      };
    }), su = P((N, c) => {
      var l = Ge(), d = tu();
      c.exports = function(h, g) {
        var _ = h[g];
        return d(_) ? void 0 : l(_);
      };
    }), tt = P((N, c) => {
      var l = Oe(), d = Ee(), h = Pe(), g = TypeError;
      c.exports = function(_, w) {
        var y, x;
        if (w === "string" && d(y = _.toString) && !h(x = l(y, _)) || d(y = _.valueOf) && !h(x = l(y, _)) || w !== "string" && d(y = _.toString) && !h(x = l(y, _)))
          return x;
        throw g("Can't convert object to primitive value");
      };
    }), rt = P((N, c) => {
      c.exports = !1;
    }), iu = P((N, c) => {
      var l = ve(), d = Object.defineProperty;
      c.exports = function(h, g) {
        try {
          d(l, h, { value: g, configurable: !0, writable: !0 });
        } catch {
          l[h] = g;
        }
        return g;
      };
    }), au = P((N, c) => {
      var l = ve(), d = iu(), h = "__core-js_shared__", g = l[h] || d(h, {});
      c.exports = g;
    }), gu = P((N, c) => {
      var l = rt(), d = au();
      (c.exports = function(h, g) {
        return d[h] || (d[h] = g !== void 0 ? g : {});
      })("versions", []).push({ version: "3.26.1", mode: l ? "pure" : "global", copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    }), Fu = P((N, c) => {
      var l = hu(), d = Object;
      c.exports = function(h) {
        return d(l(h));
      };
    }), xe = P((N, c) => {
      var l = Te(), d = Fu(), h = l({}.hasOwnProperty);
      c.exports = Object.hasOwn || function(g, _) {
        return h(d(g), _);
      };
    }), Au = P((N, c) => {
      var l = Te(), d = 0, h = Math.random(), g = l(1 .toString);
      c.exports = function(_) {
        return "Symbol(" + (_ === void 0 ? "" : _) + ")_" + g(++d + h, 36);
      };
    }), Re = P((N, c) => {
      var l = ve(), d = gu(), h = xe(), g = Au(), _ = Eu(), w = mu(), y = d("wks"), x = l.Symbol, M = x && x.for, q = w ? x : x && x.withoutSetter || g;
      c.exports = function(S) {
        if (!h(y, S) || !(_ || typeof y[S] == "string")) {
          var U = "Symbol." + S;
          _ && h(x, S) ? y[S] = x[S] : w && M ? y[S] = M(U) : y[S] = q(U);
        }
        return y[S];
      };
    }), nt = P((N, c) => {
      var l = Oe(), d = Pe(), h = fu(), g = su(), _ = tt(), w = Re(), y = TypeError, x = w("toPrimitive");
      c.exports = function(M, q) {
        if (!d(M) || h(M))
          return M;
        var S = g(M, x), U;
        if (S) {
          if (q === void 0 && (q = "default"), U = l(S, M, q), !d(U) || h(U))
            return U;
          throw y("Can't convert object to primitive value");
        }
        return q === void 0 && (q = "number"), _(M, q);
      };
    }), ou = P((N, c) => {
      var l = nt(), d = fu();
      c.exports = function(h) {
        var g = l(h, "string");
        return d(g) ? g : g + "";
      };
    }), st = P((N, c) => {
      var l = ve(), d = Pe(), h = l.document, g = d(h) && d(h.createElement);
      c.exports = function(_) {
        return g ? h.createElement(_) : {};
      };
    }), vu = P((N, c) => {
      var l = we(), d = ye(), h = st();
      c.exports = !l && !d(function() {
        return Object.defineProperty(h("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }), Tu = P((N) => {
      var c = we(), l = Oe(), d = Ku(), h = uu(), g = ru(), _ = ou(), w = xe(), y = vu(), x = Object.getOwnPropertyDescriptor;
      N.f = c ? x : function(M, q) {
        if (M = g(M), q = _(q), y)
          try {
            return x(M, q);
          } catch {
          }
        if (w(M, q))
          return h(!l(d.f, M, q), M[q]);
      };
    }), it = P((N, c) => {
      var l = we(), d = ye();
      c.exports = l && d(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: !1 }).prototype != 42;
      });
    }), Le = P((N, c) => {
      var l = Pe(), d = String, h = TypeError;
      c.exports = function(g) {
        if (l(g))
          return g;
        throw h(d(g) + " is not an object");
      };
    }), Xe = P((N) => {
      var c = we(), l = vu(), d = it(), h = Le(), g = ou(), _ = TypeError, w = Object.defineProperty, y = Object.getOwnPropertyDescriptor, x = "enumerable", M = "configurable", q = "writable";
      N.f = c ? d ? function(S, U, J) {
        if (h(S), U = g(U), h(J), typeof S == "function" && U === "prototype" && "value" in J && q in J && !J[q]) {
          var H = y(S, U);
          H && H[q] && (S[U] = J.value, J = { configurable: M in J ? J[M] : H[M], enumerable: x in J ? J[x] : H[x], writable: !1 });
        }
        return w(S, U, J);
      } : w : function(S, U, J) {
        if (h(S), U = g(U), h(J), l)
          try {
            return w(S, U, J);
          } catch {
          }
        if ("get" in J || "set" in J)
          throw _("Accessors not supported");
        return "value" in J && (S[U] = J.value), S;
      };
    }), _u = P((N, c) => {
      var l = we(), d = Xe(), h = uu();
      c.exports = l ? function(g, _, w) {
        return d.f(g, _, h(1, w));
      } : function(g, _, w) {
        return g[_] = w, g;
      };
    }), at = P((N, c) => {
      var l = we(), d = xe(), h = Function.prototype, g = l && Object.getOwnPropertyDescriptor, _ = d(h, "name"), w = _ && (function() {
      }).name === "something", y = _ && (!l || l && g(h, "name").configurable);
      c.exports = { EXISTS: _, PROPER: w, CONFIGURABLE: y };
    }), Su = P((N, c) => {
      var l = Te(), d = Ee(), h = au(), g = l(Function.toString);
      d(h.inspectSource) || (h.inspectSource = function(_) {
        return g(_);
      }), c.exports = h.inspectSource;
    }), ot = P((N, c) => {
      var l = ve(), d = Ee(), h = l.WeakMap;
      c.exports = d(h) && /native code/.test(String(h));
    }), Dt = P((N, c) => {
      var l = gu(), d = Au(), h = l("keys");
      c.exports = function(g) {
        return h[g] || (h[g] = d(g));
      };
    }), yu = P((N, c) => {
      c.exports = {};
    }), lt = P((N, c) => {
      var l = ot(), d = ve(), h = Pe(), g = _u(), _ = xe(), w = au(), y = Dt(), x = yu(), M = "Object already initialized", q = d.TypeError, S = d.WeakMap, U, J, H, Y = function(ne) {
        return H(ne) ? J(ne) : U(ne, {});
      }, Z = function(ne) {
        return function(ce) {
          var Ne;
          if (!h(ce) || (Ne = J(ce)).type !== ne)
            throw q("Incompatible receiver, " + ne + " required");
          return Ne;
        };
      };
      l || w.state ? (R = w.state || (w.state = new S()), R.get = R.get, R.has = R.has, R.set = R.set, U = function(ne, ce) {
        if (R.has(ne))
          throw q(M);
        return ce.facade = ne, R.set(ne, ce), ce;
      }, J = function(ne) {
        return R.get(ne) || {};
      }, H = function(ne) {
        return R.has(ne);
      }) : (De = y("state"), x[De] = !0, U = function(ne, ce) {
        if (_(ne, De))
          throw q(M);
        return ce.facade = ne, g(ne, De, ce), ce;
      }, J = function(ne) {
        return _(ne, De) ? ne[De] : {};
      }, H = function(ne) {
        return _(ne, De);
      });
      var R, De;
      c.exports = { set: U, get: J, has: H, enforce: Y, getterFor: Z };
    }), ct = P((N, c) => {
      var l = ye(), d = Ee(), h = xe(), g = we(), _ = at().CONFIGURABLE, w = Su(), y = lt(), x = y.enforce, M = y.get, q = Object.defineProperty, S = g && !l(function() {
        return q(function() {
        }, "length", { value: 8 }).length !== 8;
      }), U = String(String).split("String"), J = c.exports = function(H, Y, Z) {
        String(Y).slice(0, 7) === "Symbol(" && (Y = "[" + String(Y).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), Z && Z.getter && (Y = "get " + Y), Z && Z.setter && (Y = "set " + Y), (!h(H, "name") || _ && H.name !== Y) && (g ? q(H, "name", { value: Y, configurable: !0 }) : H.name = Y), S && Z && h(Z, "arity") && H.length !== Z.arity && q(H, "length", { value: Z.arity });
        try {
          Z && h(Z, "constructor") && Z.constructor ? g && q(H, "prototype", { writable: !1 }) : H.prototype && (H.prototype = void 0);
        } catch {
        }
        var R = x(H);
        return h(R, "source") || (R.source = U.join(typeof Y == "string" ? Y : "")), H;
      };
      Function.prototype.toString = J(function() {
        return d(this) && M(this).source || w(this);
      }, "toString");
    }), pt = P((N, c) => {
      var l = Ee(), d = Xe(), h = ct(), g = iu();
      c.exports = function(_, w, y, x) {
        x || (x = {});
        var M = x.enumerable, q = x.name !== void 0 ? x.name : w;
        if (l(y) && h(y, q, x), x.global)
          M ? _[w] = y : g(w, y);
        else {
          try {
            x.unsafe ? _[w] && (M = !0) : delete _[w];
          } catch {
          }
          M ? _[w] = y : d.f(_, w, { value: y, enumerable: !1, configurable: !x.nonConfigurable, writable: !x.nonWritable });
        }
        return _;
      };
    }), ht = P((N, c) => {
      var l = Math.ceil, d = Math.floor;
      c.exports = Math.trunc || function(h) {
        var g = +h;
        return (g > 0 ? d : l)(g);
      };
    }), Bu = P((N, c) => {
      var l = ht();
      c.exports = function(d) {
        var h = +d;
        return h !== h || h === 0 ? 0 : l(h);
      };
    }), dt = P((N, c) => {
      var l = Bu(), d = Math.max, h = Math.min;
      c.exports = function(g, _) {
        var w = l(g);
        return w < 0 ? d(w + _, 0) : h(w, _);
      };
    }), Ct = P((N, c) => {
      var l = Bu(), d = Math.min;
      c.exports = function(h) {
        return h > 0 ? d(l(h), 9007199254740991) : 0;
      };
    }), He = P((N, c) => {
      var l = Ct();
      c.exports = function(d) {
        return l(d.length);
      };
    }), Et = P((N, c) => {
      var l = ru(), d = dt(), h = He(), g = function(_) {
        return function(w, y, x) {
          var M = l(w), q = h(M), S = d(x, q), U;
          if (_ && y != y) {
            for (; q > S; )
              if (U = M[S++], U != U)
                return !0;
          } else
            for (; q > S; S++)
              if ((_ || S in M) && M[S] === y)
                return _ || S || 0;
          return !_ && -1;
        };
      };
      c.exports = { includes: g(!0), indexOf: g(!1) };
    }), mt = P((N, c) => {
      var l = Te(), d = xe(), h = ru(), g = Et().indexOf, _ = yu(), w = l([].push);
      c.exports = function(y, x) {
        var M = h(y), q = 0, S = [], U;
        for (U in M)
          !d(_, U) && d(M, U) && w(S, U);
        for (; x.length > q; )
          d(M, U = x[q++]) && (~g(S, U) || w(S, U));
        return S;
      };
    }), ft = P((N, c) => {
      c.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }), gt = P((N) => {
      var c = mt(), l = ft(), d = l.concat("length", "prototype");
      N.f = Object.getOwnPropertyNames || function(h) {
        return c(h, d);
      };
    }), Ft = P((N) => {
      N.f = Object.getOwnPropertySymbols;
    }), At = P((N, c) => {
      var l = Ve(), d = Te(), h = gt(), g = Ft(), _ = Le(), w = d([].concat);
      c.exports = l("Reflect", "ownKeys") || function(y) {
        var x = h.f(_(y)), M = g.f;
        return M ? w(x, M(y)) : x;
      };
    }), vt = P((N, c) => {
      var l = xe(), d = At(), h = Tu(), g = Xe();
      c.exports = function(_, w, y) {
        for (var x = d(w), M = g.f, q = h.f, S = 0; S < x.length; S++) {
          var U = x[S];
          !l(_, U) && !(y && l(y, U)) && M(_, U, q(w, U));
        }
      };
    }), Tt = P((N, c) => {
      var l = ye(), d = Ee(), h = /#|\.prototype\./, g = function(M, q) {
        var S = w[_(M)];
        return S == x ? !0 : S == y ? !1 : d(q) ? l(q) : !!q;
      }, _ = g.normalize = function(M) {
        return String(M).replace(h, ".").toLowerCase();
      }, w = g.data = {}, y = g.NATIVE = "N", x = g.POLYFILL = "P";
      c.exports = g;
    }), Du = P((N, c) => {
      var l = ve(), d = Tu().f, h = _u(), g = pt(), _ = iu(), w = vt(), y = Tt();
      c.exports = function(x, M) {
        var q = x.target, S = x.global, U = x.stat, J, H, Y, Z, R, De;
        if (S ? H = l : U ? H = l[q] || _(q, {}) : H = (l[q] || {}).prototype, H)
          for (Y in M) {
            if (R = M[Y], x.dontCallGetSet ? (De = d(H, Y), Z = De && De.value) : Z = H[Y], J = y(S ? Y : q + (U ? "." : "#") + Y, x.forced), !J && Z !== void 0) {
              if (typeof R == typeof Z)
                continue;
              w(R, Z);
            }
            (x.sham || Z && Z.sham) && h(R, "sham", !0), g(H, Y, R, x);
          }
      };
    }), _t = P(() => {
      var N = Du(), c = ve();
      N({ global: !0, forced: c.globalThis !== c }, { globalThis: c });
    }), St = P(() => {
      _t();
    }), bu = P((N, c) => {
      var l = Ue();
      c.exports = Array.isArray || function(d) {
        return l(d) == "Array";
      };
    }), yt = P((N, c) => {
      var l = TypeError, d = 9007199254740991;
      c.exports = function(h) {
        if (h > d)
          throw l("Maximum allowed index exceeded");
        return h;
      };
    }), Bt = P((N, c) => {
      var l = Ue(), d = Te();
      c.exports = function(h) {
        if (l(h) === "Function")
          return d(h);
      };
    }), wu = P((N, c) => {
      var l = Bt(), d = Ge(), h = eu(), g = l(l.bind);
      c.exports = function(_, w) {
        return d(_), w === void 0 ? _ : h ? g(_, w) : function() {
          return _.apply(w, arguments);
        };
      };
    }), bt = P((N, c) => {
      var l = bu(), d = He(), h = yt(), g = wu(), _ = function(w, y, x, M, q, S, U, J) {
        for (var H = q, Y = 0, Z = U ? g(U, J) : !1, R, De; Y < M; )
          Y in x && (R = Z ? Z(x[Y], Y, y) : x[Y], S > 0 && l(R) ? (De = d(R), H = _(w, y, R, De, H, S - 1) - 1) : (h(H + 1), w[H] = R), H++), Y++;
        return H;
      };
      c.exports = _;
    }), wt = P((N, c) => {
      var l = Re(), d = l("toStringTag"), h = {};
      h[d] = "z", c.exports = String(h) === "[object z]";
    }), xu = P((N, c) => {
      var l = wt(), d = Ee(), h = Ue(), g = Re(), _ = g("toStringTag"), w = Object, y = h(function() {
        return arguments;
      }()) == "Arguments", x = function(M, q) {
        try {
          return M[q];
        } catch {
        }
      };
      c.exports = l ? h : function(M) {
        var q, S, U;
        return M === void 0 ? "Undefined" : M === null ? "Null" : typeof (S = x(q = w(M), _)) == "string" ? S : y ? h(q) : (U = h(q)) == "Object" && d(q.callee) ? "Arguments" : U;
      };
    }), xt = P((N, c) => {
      var l = Te(), d = ye(), h = Ee(), g = xu(), _ = Ve(), w = Su(), y = function() {
      }, x = [], M = _("Reflect", "construct"), q = /^\s*(?:class|function)\b/, S = l(q.exec), U = !q.exec(y), J = function(Y) {
        if (!h(Y))
          return !1;
        try {
          return M(y, x, Y), !0;
        } catch {
          return !1;
        }
      }, H = function(Y) {
        if (!h(Y))
          return !1;
        switch (g(Y)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return !1;
        }
        try {
          return U || !!S(q, w(Y));
        } catch {
          return !0;
        }
      };
      H.sham = !0, c.exports = !M || d(function() {
        var Y;
        return J(J.call) || !J(Object) || !J(function() {
          Y = !0;
        }) || Y;
      }) ? H : J;
    }), Nt = P((N, c) => {
      var l = bu(), d = xt(), h = Pe(), g = Re(), _ = g("species"), w = Array;
      c.exports = function(y) {
        var x;
        return l(y) && (x = y.constructor, d(x) && (x === w || l(x.prototype)) ? x = void 0 : h(x) && (x = x[_], x === null && (x = void 0))), x === void 0 ? w : x;
      };
    }), kt = P((N, c) => {
      var l = Nt();
      c.exports = function(d, h) {
        return new (l(d))(h === 0 ? 0 : h);
      };
    }), Ot = P(() => {
      var N = Du(), c = bt(), l = Ge(), d = Fu(), h = He(), g = kt();
      N({ target: "Array", proto: !0 }, { flatMap: function(_) {
        var w = d(this), y = h(w), x;
        return l(_), x = g(w, 0), x.length = c(x, w, w, y, 0, 1, _, arguments.length > 1 ? arguments[1] : void 0), x;
      } });
    }), Nu = P((N, c) => {
      c.exports = {};
    }), Pt = P((N, c) => {
      var l = Re(), d = Nu(), h = l("iterator"), g = Array.prototype;
      c.exports = function(_) {
        return _ !== void 0 && (d.Array === _ || g[h] === _);
      };
    }), ku = P((N, c) => {
      var l = xu(), d = su(), h = tu(), g = Nu(), _ = Re(), w = _("iterator");
      c.exports = function(y) {
        if (!h(y))
          return d(y, w) || d(y, "@@iterator") || g[l(y)];
      };
    }), Rt = P((N, c) => {
      var l = Oe(), d = Ge(), h = Le(), g = nu(), _ = ku(), w = TypeError;
      c.exports = function(y, x) {
        var M = arguments.length < 2 ? _(y) : x;
        if (d(M))
          return h(l(M, y));
        throw w(g(y) + " is not iterable");
      };
    }), It = P((N, c) => {
      var l = Oe(), d = Le(), h = su();
      c.exports = function(g, _, w) {
        var y, x;
        d(g);
        try {
          if (y = h(g, "return"), !y) {
            if (_ === "throw")
              throw w;
            return w;
          }
          y = l(y, g);
        } catch (M) {
          x = !0, y = M;
        }
        if (_ === "throw")
          throw w;
        if (x)
          throw y;
        return d(y), w;
      };
    }), Lt = P((N, c) => {
      var l = wu(), d = Oe(), h = Le(), g = nu(), _ = Pt(), w = He(), y = Cu(), x = Rt(), M = ku(), q = It(), S = TypeError, U = function(H, Y) {
        this.stopped = H, this.result = Y;
      }, J = U.prototype;
      c.exports = function(H, Y, Z) {
        var R = Z && Z.that, De = !!(Z && Z.AS_ENTRIES), ne = !!(Z && Z.IS_RECORD), ce = !!(Z && Z.IS_ITERATOR), Ne = !!(Z && Z.INTERRUPTED), _e = l(Y, R), Se, ke, Ie, $e, me, ze, qe, Me = function(pe) {
          return Se && q(Se, "normal", pe), new U(!0, pe);
        }, We = function(pe) {
          return De ? (h(pe), Ne ? _e(pe[0], pe[1], Me) : _e(pe[0], pe[1])) : Ne ? _e(pe, Me) : _e(pe);
        };
        if (ne)
          Se = H.iterator;
        else if (ce)
          Se = H;
        else {
          if (ke = M(H), !ke)
            throw S(g(H) + " is not iterable");
          if (_(ke)) {
            for (Ie = 0, $e = w(H); $e > Ie; Ie++)
              if (me = We(H[Ie]), me && y(J, me))
                return me;
            return new U(!1);
          }
          Se = x(H, ke);
        }
        for (ze = ne ? H.next : Se.next; !(qe = d(ze, Se)).done; ) {
          try {
            me = We(qe.value);
          } catch (pe) {
            q(Se, "throw", pe);
          }
          if (typeof me == "object" && me && y(J, me))
            return me;
        }
        return new U(!1);
      };
    }), $t = P((N, c) => {
      var l = ou(), d = Xe(), h = uu();
      c.exports = function(g, _, w) {
        var y = l(_);
        y in g ? d.f(g, y, h(0, w)) : g[y] = w;
      };
    }), qt = P(() => {
      var N = Du(), c = Lt(), l = $t();
      N({ target: "Object", stat: !0 }, { fromEntries: function(d) {
        var h = {};
        return c(d, function(g, _) {
          l(h, g, _);
        }, { AS_ENTRIES: !0 }), h;
      } });
    }), Mt = P((N, c) => {
      var l = ["cliName", "cliCategory", "cliDescription"];
      function d(e, t) {
        if (e == null)
          return {};
        var a = h(e, t), o, p;
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          for (p = 0; p < r.length; p++)
            o = r[p], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (a[o] = e[o]);
        }
        return a;
      }
      function h(e, t) {
        if (e == null)
          return {};
        var a = {}, o = Object.keys(e), p, r;
        for (r = 0; r < o.length; r++)
          p = o[r], !(t.indexOf(p) >= 0) && (a[p] = e[p]);
        return a;
      }
      St(), Ot(), qt();
      var g = Object.create, _ = Object.defineProperty, w = Object.getOwnPropertyDescriptor, y = Object.getOwnPropertyNames, x = Object.getPrototypeOf, M = Object.prototype.hasOwnProperty, q = (e, t) => function() {
        return e && (t = (0, e[y(e)[0]])(e = 0)), t;
      }, S = (e, t) => function() {
        return t || (0, e[y(e)[0]])((t = { exports: {} }).exports, t), t.exports;
      }, U = (e, t) => {
        for (var a in t)
          _(e, a, { get: t[a], enumerable: !0 });
      }, J = (e, t, a, o) => {
        if (t && typeof t == "object" || typeof t == "function")
          for (let p of y(t))
            !M.call(e, p) && p !== a && _(e, p, { get: () => t[p], enumerable: !(o = w(t, p)) || o.enumerable });
        return e;
      }, H = (e, t, a) => (a = e != null ? g(x(e)) : {}, J(t || !e || !e.__esModule ? _(a, "default", { value: e, enumerable: !0 }) : a, e)), Y = (e) => J(_({}, "__esModule", { value: !0 }), e), Z, R = q({ "<define:process>"() {
        Z = { env: {}, argv: [] };
      } }), De = S({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 }), e.$EOF = 0, e.$BSPACE = 8, e.$TAB = 9, e.$LF = 10, e.$VTAB = 11, e.$FF = 12, e.$CR = 13, e.$SPACE = 32, e.$BANG = 33, e.$DQ = 34, e.$HASH = 35, e.$$ = 36, e.$PERCENT = 37, e.$AMPERSAND = 38, e.$SQ = 39, e.$LPAREN = 40, e.$RPAREN = 41, e.$STAR = 42, e.$PLUS = 43, e.$COMMA = 44, e.$MINUS = 45, e.$PERIOD = 46, e.$SLASH = 47, e.$COLON = 58, e.$SEMICOLON = 59, e.$LT = 60, e.$EQ = 61, e.$GT = 62, e.$QUESTION = 63, e.$0 = 48, e.$7 = 55, e.$9 = 57, e.$A = 65, e.$E = 69, e.$F = 70, e.$X = 88, e.$Z = 90, e.$LBRACKET = 91, e.$BACKSLASH = 92, e.$RBRACKET = 93, e.$CARET = 94, e.$_ = 95, e.$a = 97, e.$b = 98, e.$e = 101, e.$f = 102, e.$n = 110, e.$r = 114, e.$t = 116, e.$u = 117, e.$v = 118, e.$x = 120, e.$z = 122, e.$LBRACE = 123, e.$BAR = 124, e.$RBRACE = 125, e.$NBSP = 160, e.$PIPE = 124, e.$TILDA = 126, e.$AT = 64, e.$BT = 96;
        function t(m) {
          return m >= e.$TAB && m <= e.$SPACE || m == e.$NBSP;
        }
        e.isWhitespace = t;
        function a(m) {
          return e.$0 <= m && m <= e.$9;
        }
        e.isDigit = a;
        function o(m) {
          return m >= e.$a && m <= e.$z || m >= e.$A && m <= e.$Z;
        }
        e.isAsciiLetter = o;
        function p(m) {
          return m >= e.$a && m <= e.$f || m >= e.$A && m <= e.$F || a(m);
        }
        e.isAsciiHexDigit = p;
        function r(m) {
          return m === e.$LF || m === e.$CR;
        }
        e.isNewLine = r;
        function i(m) {
          return e.$0 <= m && m <= e.$7;
        }
        e.isOctalDigit = i;
      } }), ne = S({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = class {
          constructor(o, p, r) {
            this.filePath = o, this.name = p, this.members = r;
          }
          assertNoMembers() {
            if (this.members.length)
              throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
          }
        };
        e.StaticSymbol = t;
        var a = class {
          constructor() {
            this.cache = /* @__PURE__ */ new Map();
          }
          get(o, p, r) {
            r = r || [];
            let i = r.length ? `.${r.join(".")}` : "", m = `"${o}".${p}${i}`, f = this.cache.get(m);
            return f || (f = new t(o, p, r), this.cache.set(m, f)), f;
          }
        };
        e.StaticSymbolCache = a;
      } }), ce = S({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = /-+([a-z0-9])/g;
        function a(n) {
          return n.replace(t, function() {
            for (var A = arguments.length, C = new Array(A), b = 0; b < A; b++)
              C[b] = arguments[b];
            return C[1].toUpperCase();
          });
        }
        e.dashCaseToCamelCase = a;
        function o(n, A) {
          return r(n, ":", A);
        }
        e.splitAtColon = o;
        function p(n, A) {
          return r(n, ".", A);
        }
        e.splitAtPeriod = p;
        function r(n, A, C) {
          let b = n.indexOf(A);
          return b == -1 ? C : [n.slice(0, b).trim(), n.slice(b + 1).trim()];
        }
        function i(n, A, C) {
          return Array.isArray(n) ? A.visitArray(n, C) : O(n) ? A.visitStringMap(n, C) : n == null || typeof n == "string" || typeof n == "number" || typeof n == "boolean" ? A.visitPrimitive(n, C) : A.visitOther(n, C);
        }
        e.visitValue = i;
        function m(n) {
          return n != null;
        }
        e.isDefined = m;
        function f(n) {
          return n === void 0 ? null : n;
        }
        e.noUndefined = f;
        var L = class {
          visitArray(n, A) {
            return n.map((C) => i(C, this, A));
          }
          visitStringMap(n, A) {
            let C = {};
            return Object.keys(n).forEach((b) => {
              C[b] = i(n[b], this, A);
            }), C;
          }
          visitPrimitive(n, A) {
            return n;
          }
          visitOther(n, A) {
            return n;
          }
        };
        e.ValueTransformer = L, e.SyncAsync = { assertSync: (n) => {
          if (B(n))
            throw new Error("Illegal state: value cannot be a promise");
          return n;
        }, then: (n, A) => B(n) ? n.then(A) : A(n), all: (n) => n.some(B) ? Promise.all(n) : n };
        function s(n) {
          throw new Error(`Internal Error: ${n}`);
        }
        e.error = s;
        function D(n, A) {
          let C = Error(n);
          return C[E] = !0, A && (C[v] = A), C;
        }
        e.syntaxError = D;
        var E = "ngSyntaxError", v = "ngParseErrors";
        function F(n) {
          return n[E];
        }
        e.isSyntaxError = F;
        function T(n) {
          return n[v] || [];
        }
        e.getParseErrors = T;
        function $(n) {
          return n.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
        }
        e.escapeRegExp = $;
        var X = Object.getPrototypeOf({});
        function O(n) {
          return typeof n == "object" && n !== null && Object.getPrototypeOf(n) === X;
        }
        function G(n) {
          let A = "";
          for (let C = 0; C < n.length; C++) {
            let b = n.charCodeAt(C);
            if (b >= 55296 && b <= 56319 && n.length > C + 1) {
              let K = n.charCodeAt(C + 1);
              K >= 56320 && K <= 57343 && (C++, b = (b - 55296 << 10) + K - 56320 + 65536);
            }
            b <= 127 ? A += String.fromCharCode(b) : b <= 2047 ? A += String.fromCharCode(b >> 6 & 31 | 192, b & 63 | 128) : b <= 65535 ? A += String.fromCharCode(b >> 12 | 224, b >> 6 & 63 | 128, b & 63 | 128) : b <= 2097151 && (A += String.fromCharCode(b >> 18 & 7 | 240, b >> 12 & 63 | 128, b >> 6 & 63 | 128, b & 63 | 128));
          }
          return A;
        }
        e.utf8Encode = G;
        function W(n) {
          if (typeof n == "string")
            return n;
          if (n instanceof Array)
            return "[" + n.map(W).join(", ") + "]";
          if (n == null)
            return "" + n;
          if (n.overriddenName)
            return `${n.overriddenName}`;
          if (n.name)
            return `${n.name}`;
          if (!n.toString)
            return "object";
          let A = n.toString();
          if (A == null)
            return "" + A;
          let C = A.indexOf(`
`);
          return C === -1 ? A : A.substring(0, C);
        }
        e.stringify = W;
        function se(n) {
          return typeof n == "function" && n.hasOwnProperty("__forward_ref__") ? n() : n;
        }
        e.resolveForwardRef = se;
        function B(n) {
          return !!n && typeof n.then == "function";
        }
        e.isPromise = B;
        var z = class {
          constructor(n) {
            this.full = n;
            let A = n.split(".");
            this.major = A[0], this.minor = A[1], this.patch = A.slice(2).join(".");
          }
        };
        e.Version = z;
        var Q = typeof window < "u" && window, ee = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, re = typeof globalThis < "u" && globalThis, u = re || Q || ee;
        e.global = u;
      } }), Ne = S({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = ne(), a = ce(), o = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
        function p(C) {
          return C.replace(/\W/g, "_");
        }
        e.sanitizeIdentifier = p;
        var r = 0;
        function i(C) {
          if (!C || !C.reference)
            return null;
          let b = C.reference;
          if (b instanceof t.StaticSymbol)
            return b.name;
          if (b.__anonymousType)
            return b.__anonymousType;
          let K = a.stringify(b);
          return K.indexOf("(") >= 0 ? (K = `anonymous_${r++}`, b.__anonymousType = K) : K = p(K), K;
        }
        e.identifierName = i;
        function m(C) {
          let b = C.reference;
          return b instanceof t.StaticSymbol ? b.filePath : `./${a.stringify(b)}`;
        }
        e.identifierModuleUrl = m;
        function f(C, b) {
          return `View_${i({ reference: C })}_${b}`;
        }
        e.viewClassName = f;
        function L(C) {
          return `RenderType_${i({ reference: C })}`;
        }
        e.rendererTypeName = L;
        function s(C) {
          return `HostView_${i({ reference: C })}`;
        }
        e.hostViewClassName = s;
        function D(C) {
          return `${i({ reference: C })}NgFactory`;
        }
        e.componentFactoryName = D;
        var E;
        (function(C) {
          C[C.Pipe = 0] = "Pipe", C[C.Directive = 1] = "Directive", C[C.NgModule = 2] = "NgModule", C[C.Injectable = 3] = "Injectable";
        })(E = e.CompileSummaryKind || (e.CompileSummaryKind = {}));
        function v(C) {
          return C.value != null ? p(C.value) : i(C.identifier);
        }
        e.tokenName = v;
        function F(C) {
          return C.identifier != null ? C.identifier.reference : C.value;
        }
        e.tokenReference = F;
        var T = class {
          constructor() {
            let { moduleUrl: C, styles: b, styleUrls: K } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            this.moduleUrl = C || null, this.styles = B(b), this.styleUrls = B(K);
          }
        };
        e.CompileStylesheetMetadata = T;
        var $ = class {
          constructor(C) {
            let { encapsulation: b, template: K, templateUrl: te, htmlAst: le, styles: oe, styleUrls: he, externalStylesheets: de, animations: fe, ngContentSelectors: ge, interpolation: Fe, isInline: k, preserveWhitespaces: I } = C;
            if (this.encapsulation = b, this.template = K, this.templateUrl = te, this.htmlAst = le, this.styles = B(oe), this.styleUrls = B(he), this.externalStylesheets = B(de), this.animations = fe ? Q(fe) : [], this.ngContentSelectors = ge || [], Fe && Fe.length != 2)
              throw new Error("'interpolation' should have a start and an end symbol.");
            this.interpolation = Fe, this.isInline = k, this.preserveWhitespaces = I;
          }
          toSummary() {
            return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
          }
        };
        e.CompileTemplateMetadata = $;
        var X = class {
          static create(C) {
            let { isHost: b, type: K, isComponent: te, selector: le, exportAs: oe, changeDetection: he, inputs: de, outputs: fe, host: ge, providers: Fe, viewProviders: k, queries: I, guards: j, viewQueries: V, entryComponents: ue, template: ie, componentViewType: ae, rendererType: Ce, componentFactory: Be } = C, Ke = {}, Ze = {}, Hu = {};
            ge != null && Object.keys(ge).forEach((Ae) => {
              let be = ge[Ae], je = Ae.match(o);
              je === null ? Hu[Ae] = be : je[1] != null ? Ze[je[1]] = be : je[2] != null && (Ke[je[2]] = be);
            });
            let zu = {};
            de != null && de.forEach((Ae) => {
              let be = a.splitAtColon(Ae, [Ae, Ae]);
              zu[be[0]] = be[1];
            });
            let Wu = {};
            return fe != null && fe.forEach((Ae) => {
              let be = a.splitAtColon(Ae, [Ae, Ae]);
              Wu[be[0]] = be[1];
            }), new X({ isHost: b, type: K, isComponent: !!te, selector: le, exportAs: oe, changeDetection: he, inputs: zu, outputs: Wu, hostListeners: Ke, hostProperties: Ze, hostAttributes: Hu, providers: Fe, viewProviders: k, queries: I, guards: j, viewQueries: V, entryComponents: ue, template: ie, componentViewType: ae, rendererType: Ce, componentFactory: Be });
          }
          constructor(C) {
            let { isHost: b, type: K, isComponent: te, selector: le, exportAs: oe, changeDetection: he, inputs: de, outputs: fe, hostListeners: ge, hostProperties: Fe, hostAttributes: k, providers: I, viewProviders: j, queries: V, guards: ue, viewQueries: ie, entryComponents: ae, template: Ce, componentViewType: Be, rendererType: Ke, componentFactory: Ze } = C;
            this.isHost = !!b, this.type = K, this.isComponent = te, this.selector = le, this.exportAs = oe, this.changeDetection = he, this.inputs = de, this.outputs = fe, this.hostListeners = ge, this.hostProperties = Fe, this.hostAttributes = k, this.providers = B(I), this.viewProviders = B(j), this.queries = B(V), this.guards = ue, this.viewQueries = B(ie), this.entryComponents = B(ae), this.template = Ce, this.componentViewType = Be, this.rendererType = Ke, this.componentFactory = Ze;
          }
          toSummary() {
            return { summaryKind: E.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
          }
        };
        e.CompileDirectiveMetadata = X;
        var O = class {
          constructor(C) {
            let { type: b, name: K, pure: te } = C;
            this.type = b, this.name = K, this.pure = !!te;
          }
          toSummary() {
            return { summaryKind: E.Pipe, type: this.type, name: this.name, pure: this.pure };
          }
        };
        e.CompilePipeMetadata = O;
        var G = class {
        };
        e.CompileShallowModuleMetadata = G;
        var W = class {
          constructor(C) {
            let { type: b, providers: K, declaredDirectives: te, exportedDirectives: le, declaredPipes: oe, exportedPipes: he, entryComponents: de, bootstrapComponents: fe, importedModules: ge, exportedModules: Fe, schemas: k, transitiveModule: I, id: j } = C;
            this.type = b || null, this.declaredDirectives = B(te), this.exportedDirectives = B(le), this.declaredPipes = B(oe), this.exportedPipes = B(he), this.providers = B(K), this.entryComponents = B(de), this.bootstrapComponents = B(fe), this.importedModules = B(ge), this.exportedModules = B(Fe), this.schemas = B(k), this.id = j || null, this.transitiveModule = I || null;
          }
          toSummary() {
            let C = this.transitiveModule;
            return { summaryKind: E.NgModule, type: this.type, entryComponents: C.entryComponents, providers: C.providers, modules: C.modules, exportedDirectives: C.exportedDirectives, exportedPipes: C.exportedPipes };
          }
        };
        e.CompileNgModuleMetadata = W;
        var se = class {
          constructor() {
            this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
          }
          addProvider(C, b) {
            this.providers.push({ provider: C, module: b });
          }
          addDirective(C) {
            this.directivesSet.has(C.reference) || (this.directivesSet.add(C.reference), this.directives.push(C));
          }
          addExportedDirective(C) {
            this.exportedDirectivesSet.has(C.reference) || (this.exportedDirectivesSet.add(C.reference), this.exportedDirectives.push(C));
          }
          addPipe(C) {
            this.pipesSet.has(C.reference) || (this.pipesSet.add(C.reference), this.pipes.push(C));
          }
          addExportedPipe(C) {
            this.exportedPipesSet.has(C.reference) || (this.exportedPipesSet.add(C.reference), this.exportedPipes.push(C));
          }
          addModule(C) {
            this.modulesSet.has(C.reference) || (this.modulesSet.add(C.reference), this.modules.push(C));
          }
          addEntryComponent(C) {
            this.entryComponentsSet.has(C.componentType) || (this.entryComponentsSet.add(C.componentType), this.entryComponents.push(C));
          }
        };
        e.TransitiveCompileNgModuleMetadata = se;
        function B(C) {
          return C || [];
        }
        var z = class {
          constructor(C, b) {
            let { useClass: K, useValue: te, useExisting: le, useFactory: oe, deps: he, multi: de } = b;
            this.token = C, this.useClass = K || null, this.useValue = te, this.useExisting = le, this.useFactory = oe || null, this.dependencies = he || null, this.multi = !!de;
          }
        };
        e.ProviderMeta = z;
        function Q(C) {
          return C.reduce((b, K) => {
            let te = Array.isArray(K) ? Q(K) : K;
            return b.concat(te);
          }, []);
        }
        e.flatten = Q;
        function ee(C) {
          return C.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
        }
        function re(C, b, K) {
          let te;
          return K.isInline ? b.type.reference instanceof t.StaticSymbol ? te = `${b.type.reference.filePath}.${b.type.reference.name}.html` : te = `${i(C)}/${i(b.type)}.html` : te = K.templateUrl, b.type.reference instanceof t.StaticSymbol ? te : ee(te);
        }
        e.templateSourceUrl = re;
        function u(C, b) {
          let K = C.moduleUrl.split(/\/\\/g), te = K[K.length - 1];
          return ee(`css/${b}${te}.ngstyle.js`);
        }
        e.sharedStylesheetJitUrl = u;
        function n(C) {
          return ee(`${i(C.type)}/module.ngfactory.js`);
        }
        e.ngModuleJitUrl = n;
        function A(C, b) {
          return ee(`${i(C)}/${i(b.type)}.ngfactory.js`);
        }
        e.templateJitUrl = A;
      } }), _e = S({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = De(), a = Ne(), o = class {
          constructor(s, D, E, v) {
            this.file = s, this.offset = D, this.line = E, this.col = v;
          }
          toString() {
            return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
          }
          moveBy(s) {
            let D = this.file.content, E = D.length, v = this.offset, F = this.line, T = this.col;
            for (; v > 0 && s < 0; )
              if (v--, s++, D.charCodeAt(v) == t.$LF) {
                F--;
                let $ = D.substr(0, v - 1).lastIndexOf(String.fromCharCode(t.$LF));
                T = $ > 0 ? v - $ : v;
              } else
                T--;
            for (; v < E && s > 0; ) {
              let $ = D.charCodeAt(v);
              v++, s--, $ == t.$LF ? (F++, T = 0) : T++;
            }
            return new o(this.file, v, F, T);
          }
          getContext(s, D) {
            let E = this.file.content, v = this.offset;
            if (v != null) {
              v > E.length - 1 && (v = E.length - 1);
              let F = v, T = 0, $ = 0;
              for (; T < s && v > 0 && (v--, T++, !(E[v] == `
` && ++$ == D)); )
                ;
              for (T = 0, $ = 0; T < s && F < E.length - 1 && (F++, T++, !(E[F] == `
` && ++$ == D)); )
                ;
              return { before: E.substring(v, this.offset), after: E.substring(this.offset, F + 1) };
            }
            return null;
          }
        };
        e.ParseLocation = o;
        var p = class {
          constructor(s, D) {
            this.content = s, this.url = D;
          }
        };
        e.ParseSourceFile = p;
        var r = class {
          constructor(s, D) {
            let E = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            this.start = s, this.end = D, this.details = E;
          }
          toString() {
            return this.start.file.content.substring(this.start.offset, this.end.offset);
          }
        };
        e.ParseSourceSpan = r, e.EMPTY_PARSE_LOCATION = new o(new p("", ""), 0, 0, 0), e.EMPTY_SOURCE_SPAN = new r(e.EMPTY_PARSE_LOCATION, e.EMPTY_PARSE_LOCATION);
        var i;
        (function(s) {
          s[s.WARNING = 0] = "WARNING", s[s.ERROR = 1] = "ERROR";
        })(i = e.ParseErrorLevel || (e.ParseErrorLevel = {}));
        var m = class {
          constructor(s, D) {
            let E = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : i.ERROR;
            this.span = s, this.msg = D, this.level = E;
          }
          contextualMessage() {
            let s = this.span.start.getContext(100, 3);
            return s ? `${this.msg} ("${s.before}[${i[this.level]} ->]${s.after}")` : this.msg;
          }
          toString() {
            let s = this.span.details ? `, ${this.span.details}` : "";
            return `${this.contextualMessage()}: ${this.span.start}${s}`;
          }
        };
        e.ParseError = m;
        function f(s, D) {
          let E = a.identifierModuleUrl(D), v = E != null ? `in ${s} ${a.identifierName(D)} in ${E}` : `in ${s} ${a.identifierName(D)}`, F = new p("", v);
          return new r(new o(F, -1, -1, -1), new o(F, -1, -1, -1));
        }
        e.typeSourceSpan = f;
        function L(s, D, E) {
          let v = `in ${s} ${D} in ${E}`, F = new p("", v);
          return new r(new o(F, -1, -1, -1), new o(F, -1, -1, -1));
        }
        e.r3JitTypeSourceSpan = L;
      } }), Se = S({ "src/utils/front-matter/parse.js"(e, t) {
        R();
        var a = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
        function o(p) {
          let r = p.match(a);
          if (!r)
            return { content: p };
          let { startDelimiter: i, language: m, value: f = "", endDelimiter: L } = r.groups, s = m.trim() || "yaml";
          if (i === "+++" && (s = "toml"), s !== "yaml" && i !== L)
            return { content: p };
          let [D] = r;
          return { frontMatter: { type: "front-matter", lang: s, value: f, startDelimiter: i, endDelimiter: L, raw: D.replace(/\n$/, "") }, content: D.replace(/[^\n]/g, " ") + p.slice(D.length) };
        }
        t.exports = o;
      } }), ke = S({ "src/utils/get-last.js"(e, t) {
        R();
        var a = (o) => o[o.length - 1];
        t.exports = a;
      } }), Ie = S({ "src/common/parser-create-error.js"(e, t) {
        R();
        function a(o, p) {
          let r = new SyntaxError(o + " (" + p.start.line + ":" + p.start.column + ")");
          return r.loc = p, r;
        }
        t.exports = a;
      } }), $e = {};
      U($e, { default: () => me });
      function me(e) {
        if (typeof e != "string")
          throw new TypeError("Expected a string");
        return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
      }
      var ze = q({ "node_modules/escape-string-regexp/index.js"() {
        R();
      } }), qe = S({ "node_modules/semver/internal/debug.js"(e, t) {
        R();
        var a = typeof Z == "object" && Z.env && Z.env.NODE_DEBUG && /\bsemver\b/i.test(Z.env.NODE_DEBUG) ? function() {
          for (var o = arguments.length, p = new Array(o), r = 0; r < o; r++)
            p[r] = arguments[r];
          return console.error("SEMVER", ...p);
        } : () => {
        };
        t.exports = a;
      } }), Me = S({ "node_modules/semver/internal/constants.js"(e, t) {
        R();
        var a = "2.0.0", o = 256, p = Number.MAX_SAFE_INTEGER || 9007199254740991, r = 16;
        t.exports = { SEMVER_SPEC_VERSION: a, MAX_LENGTH: o, MAX_SAFE_INTEGER: p, MAX_SAFE_COMPONENT_LENGTH: r };
      } }), We = S({ "node_modules/semver/internal/re.js"(e, t) {
        R();
        var { MAX_SAFE_COMPONENT_LENGTH: a } = Me(), o = qe();
        e = t.exports = {};
        var p = e.re = [], r = e.src = [], i = e.t = {}, m = 0, f = (L, s, D) => {
          let E = m++;
          o(L, E, s), i[L] = E, r[E] = s, p[E] = new RegExp(s, D ? "g" : void 0);
        };
        f("NUMERICIDENTIFIER", "0|[1-9]\\d*"), f("NUMERICIDENTIFIERLOOSE", "[0-9]+"), f("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), f("MAINVERSION", `(${r[i.NUMERICIDENTIFIER]})\\.(${r[i.NUMERICIDENTIFIER]})\\.(${r[i.NUMERICIDENTIFIER]})`), f("MAINVERSIONLOOSE", `(${r[i.NUMERICIDENTIFIERLOOSE]})\\.(${r[i.NUMERICIDENTIFIERLOOSE]})\\.(${r[i.NUMERICIDENTIFIERLOOSE]})`), f("PRERELEASEIDENTIFIER", `(?:${r[i.NUMERICIDENTIFIER]}|${r[i.NONNUMERICIDENTIFIER]})`), f("PRERELEASEIDENTIFIERLOOSE", `(?:${r[i.NUMERICIDENTIFIERLOOSE]}|${r[i.NONNUMERICIDENTIFIER]})`), f("PRERELEASE", `(?:-(${r[i.PRERELEASEIDENTIFIER]}(?:\\.${r[i.PRERELEASEIDENTIFIER]})*))`), f("PRERELEASELOOSE", `(?:-?(${r[i.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${r[i.PRERELEASEIDENTIFIERLOOSE]})*))`), f("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), f("BUILD", `(?:\\+(${r[i.BUILDIDENTIFIER]}(?:\\.${r[i.BUILDIDENTIFIER]})*))`), f("FULLPLAIN", `v?${r[i.MAINVERSION]}${r[i.PRERELEASE]}?${r[i.BUILD]}?`), f("FULL", `^${r[i.FULLPLAIN]}$`), f("LOOSEPLAIN", `[v=\\s]*${r[i.MAINVERSIONLOOSE]}${r[i.PRERELEASELOOSE]}?${r[i.BUILD]}?`), f("LOOSE", `^${r[i.LOOSEPLAIN]}$`), f("GTLT", "((?:<|>)?=?)"), f("XRANGEIDENTIFIERLOOSE", `${r[i.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), f("XRANGEIDENTIFIER", `${r[i.NUMERICIDENTIFIER]}|x|X|\\*`), f("XRANGEPLAIN", `[v=\\s]*(${r[i.XRANGEIDENTIFIER]})(?:\\.(${r[i.XRANGEIDENTIFIER]})(?:\\.(${r[i.XRANGEIDENTIFIER]})(?:${r[i.PRERELEASE]})?${r[i.BUILD]}?)?)?`), f("XRANGEPLAINLOOSE", `[v=\\s]*(${r[i.XRANGEIDENTIFIERLOOSE]})(?:\\.(${r[i.XRANGEIDENTIFIERLOOSE]})(?:\\.(${r[i.XRANGEIDENTIFIERLOOSE]})(?:${r[i.PRERELEASELOOSE]})?${r[i.BUILD]}?)?)?`), f("XRANGE", `^${r[i.GTLT]}\\s*${r[i.XRANGEPLAIN]}$`), f("XRANGELOOSE", `^${r[i.GTLT]}\\s*${r[i.XRANGEPLAINLOOSE]}$`), f("COERCE", `(^|[^\\d])(\\d{1,${a}})(?:\\.(\\d{1,${a}}))?(?:\\.(\\d{1,${a}}))?(?:$|[^\\d])`), f("COERCERTL", r[i.COERCE], !0), f("LONETILDE", "(?:~>?)"), f("TILDETRIM", `(\\s*)${r[i.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", f("TILDE", `^${r[i.LONETILDE]}${r[i.XRANGEPLAIN]}$`), f("TILDELOOSE", `^${r[i.LONETILDE]}${r[i.XRANGEPLAINLOOSE]}$`), f("LONECARET", "(?:\\^)"), f("CARETTRIM", `(\\s*)${r[i.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", f("CARET", `^${r[i.LONECARET]}${r[i.XRANGEPLAIN]}$`), f("CARETLOOSE", `^${r[i.LONECARET]}${r[i.XRANGEPLAINLOOSE]}$`), f("COMPARATORLOOSE", `^${r[i.GTLT]}\\s*(${r[i.LOOSEPLAIN]})$|^$`), f("COMPARATOR", `^${r[i.GTLT]}\\s*(${r[i.FULLPLAIN]})$|^$`), f("COMPARATORTRIM", `(\\s*)${r[i.GTLT]}\\s*(${r[i.LOOSEPLAIN]}|${r[i.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", f("HYPHENRANGE", `^\\s*(${r[i.XRANGEPLAIN]})\\s+-\\s+(${r[i.XRANGEPLAIN]})\\s*$`), f("HYPHENRANGELOOSE", `^\\s*(${r[i.XRANGEPLAINLOOSE]})\\s+-\\s+(${r[i.XRANGEPLAINLOOSE]})\\s*$`), f("STAR", "(<|>)?=?\\s*\\*"), f("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), f("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
      } }), pe = S({ "node_modules/semver/internal/parse-options.js"(e, t) {
        R();
        var a = ["includePrerelease", "loose", "rtl"], o = (p) => p ? typeof p != "object" ? { loose: !0 } : a.filter((r) => p[r]).reduce((r, i) => (r[i] = !0, r), {}) : {};
        t.exports = o;
      } }), jt = S({ "node_modules/semver/internal/identifiers.js"(e, t) {
        R();
        var a = /^[0-9]+$/, o = (r, i) => {
          let m = a.test(r), f = a.test(i);
          return m && f && (r = +r, i = +i), r === i ? 0 : m && !f ? -1 : f && !m ? 1 : r < i ? -1 : 1;
        }, p = (r, i) => o(i, r);
        t.exports = { compareIdentifiers: o, rcompareIdentifiers: p };
      } }), Ut = S({ "node_modules/semver/classes/semver.js"(e, t) {
        R();
        var a = qe(), { MAX_LENGTH: o, MAX_SAFE_INTEGER: p } = Me(), { re: r, t: i } = We(), m = pe(), { compareIdentifiers: f } = jt(), L = class {
          constructor(s, D) {
            if (D = m(D), s instanceof L) {
              if (s.loose === !!D.loose && s.includePrerelease === !!D.includePrerelease)
                return s;
              s = s.version;
            } else if (typeof s != "string")
              throw new TypeError(`Invalid Version: ${s}`);
            if (s.length > o)
              throw new TypeError(`version is longer than ${o} characters`);
            a("SemVer", s, D), this.options = D, this.loose = !!D.loose, this.includePrerelease = !!D.includePrerelease;
            let E = s.trim().match(D.loose ? r[i.LOOSE] : r[i.FULL]);
            if (!E)
              throw new TypeError(`Invalid Version: ${s}`);
            if (this.raw = s, this.major = +E[1], this.minor = +E[2], this.patch = +E[3], this.major > p || this.major < 0)
              throw new TypeError("Invalid major version");
            if (this.minor > p || this.minor < 0)
              throw new TypeError("Invalid minor version");
            if (this.patch > p || this.patch < 0)
              throw new TypeError("Invalid patch version");
            E[4] ? this.prerelease = E[4].split(".").map((v) => {
              if (/^[0-9]+$/.test(v)) {
                let F = +v;
                if (F >= 0 && F < p)
                  return F;
              }
              return v;
            }) : this.prerelease = [], this.build = E[5] ? E[5].split(".") : [], this.format();
          }
          format() {
            return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
          }
          toString() {
            return this.version;
          }
          compare(s) {
            if (a("SemVer.compare", this.version, this.options, s), !(s instanceof L)) {
              if (typeof s == "string" && s === this.version)
                return 0;
              s = new L(s, this.options);
            }
            return s.version === this.version ? 0 : this.compareMain(s) || this.comparePre(s);
          }
          compareMain(s) {
            return s instanceof L || (s = new L(s, this.options)), f(this.major, s.major) || f(this.minor, s.minor) || f(this.patch, s.patch);
          }
          comparePre(s) {
            if (s instanceof L || (s = new L(s, this.options)), this.prerelease.length && !s.prerelease.length)
              return -1;
            if (!this.prerelease.length && s.prerelease.length)
              return 1;
            if (!this.prerelease.length && !s.prerelease.length)
              return 0;
            let D = 0;
            do {
              let E = this.prerelease[D], v = s.prerelease[D];
              if (a("prerelease compare", D, E, v), E === void 0 && v === void 0)
                return 0;
              if (v === void 0)
                return 1;
              if (E === void 0)
                return -1;
              if (E !== v)
                return f(E, v);
            } while (++D);
          }
          compareBuild(s) {
            s instanceof L || (s = new L(s, this.options));
            let D = 0;
            do {
              let E = this.build[D], v = s.build[D];
              if (a("prerelease compare", D, E, v), E === void 0 && v === void 0)
                return 0;
              if (v === void 0)
                return 1;
              if (E === void 0)
                return -1;
              if (E !== v)
                return f(E, v);
            } while (++D);
          }
          inc(s, D) {
            switch (s) {
              case "premajor":
                this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", D);
                break;
              case "preminor":
                this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", D);
                break;
              case "prepatch":
                this.prerelease.length = 0, this.inc("patch", D), this.inc("pre", D);
                break;
              case "prerelease":
                this.prerelease.length === 0 && this.inc("patch", D), this.inc("pre", D);
                break;
              case "major":
                (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                break;
              case "minor":
                (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                break;
              case "patch":
                this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                break;
              case "pre":
                if (this.prerelease.length === 0)
                  this.prerelease = [0];
                else {
                  let E = this.prerelease.length;
                  for (; --E >= 0; )
                    typeof this.prerelease[E] == "number" && (this.prerelease[E]++, E = -2);
                  E === -1 && this.prerelease.push(0);
                }
                D && (f(this.prerelease[0], D) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [D, 0]) : this.prerelease = [D, 0]);
                break;
              default:
                throw new Error(`invalid increment argument: ${s}`);
            }
            return this.format(), this.raw = this.version, this;
          }
        };
        t.exports = L;
      } }), lu = S({ "node_modules/semver/functions/compare.js"(e, t) {
        R();
        var a = Ut(), o = (p, r, i) => new a(p, i).compare(new a(r, i));
        t.exports = o;
      } }), Vt = S({ "node_modules/semver/functions/lt.js"(e, t) {
        R();
        var a = lu(), o = (p, r, i) => a(p, r, i) < 0;
        t.exports = o;
      } }), Gt = S({ "node_modules/semver/functions/gte.js"(e, t) {
        R();
        var a = lu(), o = (p, r, i) => a(p, r, i) >= 0;
        t.exports = o;
      } }), Xt = S({ "src/utils/arrayify.js"(e, t) {
        R(), t.exports = (a, o) => Object.entries(a).map((p) => {
          let [r, i] = p;
          return Object.assign({ [o]: r }, i);
        });
      } }), Ht = S({ "package.json"(e, t) {
        t.exports = { version: "2.8.8" };
      } }), zt = S({ "node_modules/outdent/lib/index.js"(e, t) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 }), e.outdent = void 0;
        function a() {
          for (var O = [], G = 0; G < arguments.length; G++)
            O[G] = arguments[G];
        }
        function o() {
          return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : p();
        }
        function p() {
          return { add: a, delete: a, get: a, set: a, has: function(O) {
            return !1;
          } };
        }
        var r = Object.prototype.hasOwnProperty, i = function(O, G) {
          return r.call(O, G);
        };
        function m(O, G) {
          for (var W in G)
            i(G, W) && (O[W] = G[W]);
          return O;
        }
        var f = /^[ \t]*(?:\r\n|\r|\n)/, L = /(?:\r\n|\r|\n)[ \t]*$/, s = /^(?:[\r\n]|$)/, D = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, E = /^[ \t]*[\r\n][ \t\r\n]*$/;
        function v(O, G, W) {
          var se = 0, B = O[0].match(D);
          B && (se = B[1].length);
          var z = "(\\r\\n|\\r|\\n).{0," + se + "}", Q = new RegExp(z, "g");
          G && (O = O.slice(1));
          var ee = W.newline, re = W.trimLeadingNewline, u = W.trimTrailingNewline, n = typeof ee == "string", A = O.length, C = O.map(function(b, K) {
            return b = b.replace(Q, "$1"), K === 0 && re && (b = b.replace(f, "")), K === A - 1 && u && (b = b.replace(L, "")), n && (b = b.replace(/\r\n|\n|\r/g, function(te) {
              return ee;
            })), b;
          });
          return C;
        }
        function F(O, G) {
          for (var W = "", se = 0, B = O.length; se < B; se++)
            W += O[se], se < B - 1 && (W += G[se]);
          return W;
        }
        function T(O) {
          return i(O, "raw") && i(O, "length");
        }
        function $(O) {
          var G = o(), W = o();
          function se(z) {
            for (var Q = [], ee = 1; ee < arguments.length; ee++)
              Q[ee - 1] = arguments[ee];
            if (T(z)) {
              var re = z, u = (Q[0] === se || Q[0] === X) && E.test(re[0]) && s.test(re[1]), n = u ? W : G, A = n.get(re);
              if (A || (A = v(re, u, O), n.set(re, A)), Q.length === 0)
                return A[0];
              var C = F(A, u ? Q.slice(1) : Q);
              return C;
            } else
              return $(m(m({}, O), z || {}));
          }
          var B = m(se, { string: function(z) {
            return v([z], !1, O)[0];
          } });
          return B;
        }
        var X = $({ trimLeadingNewline: !0, trimTrailingNewline: !0 });
        if (e.outdent = X, e.default = X, typeof t < "u")
          try {
            t.exports = X, Object.defineProperty(X, "__esModule", { value: !0 }), X.default = X, X.outdent = X;
          } catch {
          }
      } }), Wt = S({ "src/main/core-options.js"(e, t) {
        R();
        var { outdent: a } = zt(), o = "Config", p = "Editor", r = "Format", i = "Other", m = "Output", f = "Global", L = "Special", s = { cursorOffset: { since: "1.4.0", category: L, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: a`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: p }, endOfLine: { since: "1.15.0", category: f, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: a`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: L, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: i, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: L, type: "boolean", default: !1, description: "Insert @format pragma into file's first docblock comment.", cliCategory: i }, parser: { since: "0.0.10", category: f, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (D) => typeof D == "string" || typeof D == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: !0, default: [{ value: [] }], category: f, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (D) => typeof D == "string" || typeof D == "object", cliName: "plugin", cliCategory: o }, pluginSearchDirs: { since: "1.13.0", type: "path", array: !0, default: [{ value: [] }], category: f, description: a`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (D) => typeof D == "string" || typeof D == "object", cliName: "plugin-search-dir", cliCategory: o }, printWidth: { since: "0.0.0", category: f, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: L, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: a`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: p }, rangeStart: { since: "1.4.0", category: L, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: a`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: p }, requirePragma: { since: "1.7.0", category: L, type: "boolean", default: !1, description: a`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: i }, tabWidth: { type: "int", category: f, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: f, type: "boolean", default: !1, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: f, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
        t.exports = { CATEGORY_CONFIG: o, CATEGORY_EDITOR: p, CATEGORY_FORMAT: r, CATEGORY_OTHER: i, CATEGORY_OUTPUT: m, CATEGORY_GLOBAL: f, CATEGORY_SPECIAL: L, options: s };
      } }), Qt = S({ "src/main/support.js"(e, t) {
        R();
        var a = { compare: lu(), lt: Vt(), gte: Gt() }, o = Xt(), p = Ht().version, r = Wt().options;
        function i() {
          let { plugins: f = [], showUnreleased: L = !1, showDeprecated: s = !1, showInternal: D = !1 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, E = p.split("-", 1)[0], v = f.flatMap((O) => O.languages || []).filter(T), F = o(Object.assign({}, ...f.map((O) => {
            let { options: G } = O;
            return G;
          }), r), "name").filter((O) => T(O) && $(O)).sort((O, G) => O.name === G.name ? 0 : O.name < G.name ? -1 : 1).map(X).map((O) => {
            O = Object.assign({}, O), Array.isArray(O.default) && (O.default = O.default.length === 1 ? O.default[0].value : O.default.filter(T).sort((W, se) => a.compare(se.since, W.since))[0].value), Array.isArray(O.choices) && (O.choices = O.choices.filter((W) => T(W) && $(W)), O.name === "parser" && m(O, v, f));
            let G = Object.fromEntries(f.filter((W) => W.defaultOptions && W.defaultOptions[O.name] !== void 0).map((W) => [W.name, W.defaultOptions[O.name]]));
            return Object.assign(Object.assign({}, O), {}, { pluginDefaults: G });
          });
          return { languages: v, options: F };
          function T(O) {
            return L || !("since" in O) || O.since && a.gte(E, O.since);
          }
          function $(O) {
            return s || !("deprecated" in O) || O.deprecated && a.lt(E, O.deprecated);
          }
          function X(O) {
            return D ? O : d(O, l);
          }
        }
        function m(f, L, s) {
          let D = new Set(f.choices.map((E) => E.value));
          for (let E of L)
            if (E.parsers) {
              for (let v of E.parsers)
                if (!D.has(v)) {
                  D.add(v);
                  let F = s.find(($) => $.parsers && $.parsers[v]), T = E.name;
                  F && F.name && (T += ` (plugin: ${F.name})`), f.choices.push({ value: v, description: T });
                }
            }
        }
        t.exports = { getSupportInfo: i };
      } }), Yt = S({ "src/utils/is-non-empty-array.js"(e, t) {
        R();
        function a(o) {
          return Array.isArray(o) && o.length > 0;
        }
        t.exports = a;
      } });
      function Jt() {
        let { onlyFirst: e = !1 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
        return new RegExp(t, e ? void 0 : "g");
      }
      var Kt = q({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
        R();
      } });
      function Zt(e) {
        if (typeof e != "string")
          throw new TypeError(`Expected a \`string\`, got \`${typeof e}\``);
        return e.replace(Jt(), "");
      }
      var er = q({ "node_modules/strip-ansi/index.js"() {
        R(), Kt();
      } });
      function ur(e) {
        return Number.isInteger(e) ? e >= 4352 && (e <= 4447 || e === 9001 || e === 9002 || 11904 <= e && e <= 12871 && e !== 12351 || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141) : !1;
      }
      var tr = q({ "node_modules/is-fullwidth-code-point/index.js"() {
        R();
      } }), rr = S({ "node_modules/emoji-regex/index.js"(e, t) {
        R(), t.exports = function() {
          return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
        };
      } }), Ou = {};
      U(Ou, { default: () => nr });
      function nr(e) {
        if (typeof e != "string" || e.length === 0 || (e = Zt(e), e.length === 0))
          return 0;
        e = e.replace((0, Pu.default)(), "  ");
        let t = 0;
        for (let a = 0; a < e.length; a++) {
          let o = e.codePointAt(a);
          o <= 31 || o >= 127 && o <= 159 || o >= 768 && o <= 879 || (o > 65535 && a++, t += ur(o) ? 2 : 1);
        }
        return t;
      }
      var Pu, sr = q({ "node_modules/string-width/index.js"() {
        R(), er(), tr(), Pu = H(rr());
      } }), ir = S({ "src/utils/get-string-width.js"(e, t) {
        R();
        var a = (sr(), Y(Ou)).default, o = /[^\x20-\x7F]/;
        function p(r) {
          return r ? o.test(r) ? a(r) : r.length : 0;
        }
        t.exports = p;
      } }), cu = S({ "src/utils/text/skip.js"(e, t) {
        R();
        function a(m) {
          return (f, L, s) => {
            let D = s && s.backwards;
            if (L === !1)
              return !1;
            let { length: E } = f, v = L;
            for (; v >= 0 && v < E; ) {
              let F = f.charAt(v);
              if (m instanceof RegExp) {
                if (!m.test(F))
                  return v;
              } else if (!m.includes(F))
                return v;
              D ? v-- : v++;
            }
            return v === -1 || v === E ? v : !1;
          };
        }
        var o = a(/\s/), p = a(" 	"), r = a(",; 	"), i = a(/[^\n\r]/);
        t.exports = { skipWhitespace: o, skipSpaces: p, skipToLineEnd: r, skipEverythingButNewLine: i };
      } }), Ru = S({ "src/utils/text/skip-inline-comment.js"(e, t) {
        R();
        function a(o, p) {
          if (p === !1)
            return !1;
          if (o.charAt(p) === "/" && o.charAt(p + 1) === "*") {
            for (let r = p + 2; r < o.length; ++r)
              if (o.charAt(r) === "*" && o.charAt(r + 1) === "/")
                return r + 2;
          }
          return p;
        }
        t.exports = a;
      } }), Iu = S({ "src/utils/text/skip-trailing-comment.js"(e, t) {
        R();
        var { skipEverythingButNewLine: a } = cu();
        function o(p, r) {
          return r === !1 ? !1 : p.charAt(r) === "/" && p.charAt(r + 1) === "/" ? a(p, r) : r;
        }
        t.exports = o;
      } }), Lu = S({ "src/utils/text/skip-newline.js"(e, t) {
        R();
        function a(o, p, r) {
          let i = r && r.backwards;
          if (p === !1)
            return !1;
          let m = o.charAt(p);
          if (i) {
            if (o.charAt(p - 1) === "\r" && m === `
`)
              return p - 2;
            if (m === `
` || m === "\r" || m === "\u2028" || m === "\u2029")
              return p - 1;
          } else {
            if (m === "\r" && o.charAt(p + 1) === `
`)
              return p + 2;
            if (m === `
` || m === "\r" || m === "\u2028" || m === "\u2029")
              return p + 1;
          }
          return p;
        }
        t.exports = a;
      } }), ar = S({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e, t) {
        R();
        var a = Ru(), o = Lu(), p = Iu(), { skipSpaces: r } = cu();
        function i(m, f) {
          let L = null, s = f;
          for (; s !== L; )
            L = s, s = r(m, s), s = a(m, s), s = p(m, s), s = o(m, s);
          return s;
        }
        t.exports = i;
      } }), or = S({ "src/common/util.js"(e, t) {
        R();
        var { default: a } = (ze(), Y($e)), o = ke(), { getSupportInfo: p } = Qt(), r = Yt(), i = ir(), { skipWhitespace: m, skipSpaces: f, skipToLineEnd: L, skipEverythingButNewLine: s } = cu(), D = Ru(), E = Iu(), v = Lu(), F = ar(), T = (k) => k[k.length - 2];
        function $(k) {
          return (I, j, V) => {
            let ue = V && V.backwards;
            if (j === !1)
              return !1;
            let { length: ie } = I, ae = j;
            for (; ae >= 0 && ae < ie; ) {
              let Ce = I.charAt(ae);
              if (k instanceof RegExp) {
                if (!k.test(Ce))
                  return ae;
              } else if (!k.includes(Ce))
                return ae;
              ue ? ae-- : ae++;
            }
            return ae === -1 || ae === ie ? ae : !1;
          };
        }
        function X(k, I) {
          let j = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, V = f(k, j.backwards ? I - 1 : I, j), ue = v(k, V, j);
          return V !== ue;
        }
        function O(k, I, j) {
          for (let V = I; V < j; ++V)
            if (k.charAt(V) === `
`)
              return !0;
          return !1;
        }
        function G(k, I, j) {
          let V = j(I) - 1;
          V = f(k, V, { backwards: !0 }), V = v(k, V, { backwards: !0 }), V = f(k, V, { backwards: !0 });
          let ue = v(k, V, { backwards: !0 });
          return V !== ue;
        }
        function W(k, I) {
          let j = null, V = I;
          for (; V !== j; )
            j = V, V = L(k, V), V = D(k, V), V = f(k, V);
          return V = E(k, V), V = v(k, V), V !== !1 && X(k, V);
        }
        function se(k, I, j) {
          return W(k, j(I));
        }
        function B(k, I, j) {
          return F(k, j(I));
        }
        function z(k, I, j) {
          return k.charAt(B(k, I, j));
        }
        function Q(k, I) {
          let j = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return f(k, j.backwards ? I - 1 : I, j) !== I;
        }
        function ee(k, I) {
          let j = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, V = 0;
          for (let ue = j; ue < k.length; ++ue)
            k[ue] === "	" ? V = V + I - V % I : V++;
          return V;
        }
        function re(k, I) {
          let j = k.lastIndexOf(`
`);
          return j === -1 ? 0 : ee(k.slice(j + 1).match(/^[\t ]*/)[0], I);
        }
        function u(k, I) {
          let j = { quote: '"', regex: /"/g, escaped: "&quot;" }, V = { quote: "'", regex: /'/g, escaped: "&apos;" }, ue = I === "'" ? V : j, ie = ue === V ? j : V, ae = ue;
          if (k.includes(ue.quote) || k.includes(ie.quote)) {
            let Ce = (k.match(ue.regex) || []).length, Be = (k.match(ie.regex) || []).length;
            ae = Ce > Be ? ie : ue;
          }
          return ae;
        }
        function n(k, I) {
          let j = k.slice(1, -1), V = I.parser === "json" || I.parser === "json5" && I.quoteProps === "preserve" && !I.singleQuote ? '"' : I.__isInHtmlAttribute ? "'" : u(j, I.singleQuote ? "'" : '"').quote;
          return A(j, V, !(I.parser === "css" || I.parser === "less" || I.parser === "scss" || I.__embeddedInHtml));
        }
        function A(k, I, j) {
          let V = I === '"' ? "'" : '"', ue = /\\(.)|(["'])/gs, ie = k.replace(ue, (ae, Ce, Be) => Ce === V ? Ce : Be === I ? "\\" + Be : Be || (j && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(Ce) ? Ce : "\\" + Ce));
          return I + ie + I;
        }
        function C(k) {
          return k.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
        }
        function b(k, I) {
          let j = k.match(new RegExp(`(${a(I)})+`, "g"));
          return j === null ? 0 : j.reduce((V, ue) => Math.max(V, ue.length / I.length), 0);
        }
        function K(k, I) {
          let j = k.match(new RegExp(`(${a(I)})+`, "g"));
          if (j === null)
            return 0;
          let V = /* @__PURE__ */ new Map(), ue = 0;
          for (let ie of j) {
            let ae = ie.length / I.length;
            V.set(ae, !0), ae > ue && (ue = ae);
          }
          for (let ie = 1; ie < ue; ie++)
            if (!V.get(ie))
              return ie;
          return ue + 1;
        }
        function te(k, I) {
          (k.comments || (k.comments = [])).push(I), I.printed = !1, I.nodeDescription = Fe(k);
        }
        function le(k, I) {
          I.leading = !0, I.trailing = !1, te(k, I);
        }
        function oe(k, I, j) {
          I.leading = !1, I.trailing = !1, j && (I.marker = j), te(k, I);
        }
        function he(k, I) {
          I.leading = !1, I.trailing = !0, te(k, I);
        }
        function de(k, I) {
          let { languages: j } = p({ plugins: I.plugins }), V = j.find((ue) => {
            let { name: ie } = ue;
            return ie.toLowerCase() === k;
          }) || j.find((ue) => {
            let { aliases: ie } = ue;
            return Array.isArray(ie) && ie.includes(k);
          }) || j.find((ue) => {
            let { extensions: ie } = ue;
            return Array.isArray(ie) && ie.includes(`.${k}`);
          });
          return V && V.parsers[0];
        }
        function fe(k) {
          return k && k.type === "front-matter";
        }
        function ge(k) {
          let I = /* @__PURE__ */ new WeakMap();
          return function(j) {
            return I.has(j) || I.set(j, Symbol(k)), I.get(j);
          };
        }
        function Fe(k) {
          let I = k.type || k.kind || "(unknown type)", j = String(k.name || k.id && (typeof k.id == "object" ? k.id.name : k.id) || k.key && (typeof k.key == "object" ? k.key.name : k.key) || k.value && (typeof k.value == "object" ? "" : String(k.value)) || k.operator || "");
          return j.length > 20 && (j = j.slice(0, 19) + "…"), I + (j ? " " + j : "");
        }
        t.exports = { inferParserByLanguage: de, getStringWidth: i, getMaxContinuousCount: b, getMinNotPresentContinuousCount: K, getPenultimate: T, getLast: o, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: F, getNextNonSpaceNonCommentCharacterIndex: B, getNextNonSpaceNonCommentCharacter: z, skip: $, skipWhitespace: m, skipSpaces: f, skipToLineEnd: L, skipEverythingButNewLine: s, skipInlineComment: D, skipTrailingComment: E, skipNewline: v, isNextLineEmptyAfterIndex: W, isNextLineEmpty: se, isPreviousLineEmpty: G, hasNewline: X, hasNewlineInRange: O, hasSpaces: Q, getAlignmentSize: ee, getIndentSize: re, getPreferredQuote: u, printString: n, printNumber: C, makeString: A, addLeadingComment: le, addDanglingComment: oe, addTrailingComment: he, isFrontMatterNode: fe, isNonEmptyArray: r, createGroupIdMapper: ge };
      } }), Dr = S({ "vendors/html-tag-names.json"(e, t) {
        t.exports = { htmlTagNames: ["a", "abbr", "acronym", "address", "applet", "area", "article", "aside", "audio", "b", "base", "basefont", "bdi", "bdo", "bgsound", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "command", "content", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "image", "img", "input", "ins", "isindex", "kbd", "keygen", "label", "legend", "li", "link", "listing", "main", "map", "mark", "marquee", "math", "menu", "menuitem", "meta", "meter", "multicol", "nav", "nextid", "nobr", "noembed", "noframes", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "plaintext", "pre", "progress", "q", "rb", "rbc", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "tt", "u", "ul", "var", "video", "wbr", "xmp"] };
      } }), $u = S({ "src/language-html/utils/array-to-map.js"(e, t) {
        R();
        function a(o) {
          let p = /* @__PURE__ */ Object.create(null);
          for (let r of o)
            p[r] = !0;
          return p;
        }
        t.exports = a;
      } }), lr = S({ "src/language-html/utils/html-tag-names.js"(e, t) {
        R();
        var { htmlTagNames: a } = Dr(), o = $u(), p = o(a);
        t.exports = p;
      } }), cr = S({ "vendors/html-element-attributes.json"(e, t) {
        t.exports = { htmlElementAttributes: { "*": ["accesskey", "autocapitalize", "autofocus", "class", "contenteditable", "dir", "draggable", "enterkeyhint", "hidden", "id", "inputmode", "is", "itemid", "itemprop", "itemref", "itemscope", "itemtype", "lang", "nonce", "slot", "spellcheck", "style", "tabindex", "title", "translate"], a: ["charset", "coords", "download", "href", "hreflang", "name", "ping", "referrerpolicy", "rel", "rev", "shape", "target", "type"], applet: ["align", "alt", "archive", "code", "codebase", "height", "hspace", "name", "object", "vspace", "width"], area: ["alt", "coords", "download", "href", "hreflang", "nohref", "ping", "referrerpolicy", "rel", "shape", "target", "type"], audio: ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"], base: ["href", "target"], basefont: ["color", "face", "size"], blockquote: ["cite"], body: ["alink", "background", "bgcolor", "link", "text", "vlink"], br: ["clear"], button: ["disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "name", "type", "value"], canvas: ["height", "width"], caption: ["align"], col: ["align", "char", "charoff", "span", "valign", "width"], colgroup: ["align", "char", "charoff", "span", "valign", "width"], data: ["value"], del: ["cite", "datetime"], details: ["open"], dialog: ["open"], dir: ["compact"], div: ["align"], dl: ["compact"], embed: ["height", "src", "type", "width"], fieldset: ["disabled", "form", "name"], font: ["color", "face", "size"], form: ["accept", "accept-charset", "action", "autocomplete", "enctype", "method", "name", "novalidate", "target"], frame: ["frameborder", "longdesc", "marginheight", "marginwidth", "name", "noresize", "scrolling", "src"], frameset: ["cols", "rows"], h1: ["align"], h2: ["align"], h3: ["align"], h4: ["align"], h5: ["align"], h6: ["align"], head: ["profile"], hr: ["align", "noshade", "size", "width"], html: ["manifest", "version"], iframe: ["align", "allow", "allowfullscreen", "allowpaymentrequest", "allowusermedia", "frameborder", "height", "loading", "longdesc", "marginheight", "marginwidth", "name", "referrerpolicy", "sandbox", "scrolling", "src", "srcdoc", "width"], img: ["align", "alt", "border", "crossorigin", "decoding", "height", "hspace", "ismap", "loading", "longdesc", "name", "referrerpolicy", "sizes", "src", "srcset", "usemap", "vspace", "width"], input: ["accept", "align", "alt", "autocomplete", "checked", "dirname", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "height", "ismap", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "src", "step", "type", "usemap", "value", "width"], ins: ["cite", "datetime"], isindex: ["prompt"], label: ["for", "form"], legend: ["align"], li: ["type", "value"], link: ["as", "charset", "color", "crossorigin", "disabled", "href", "hreflang", "imagesizes", "imagesrcset", "integrity", "media", "referrerpolicy", "rel", "rev", "sizes", "target", "type"], map: ["name"], menu: ["compact"], meta: ["charset", "content", "http-equiv", "media", "name", "scheme"], meter: ["high", "low", "max", "min", "optimum", "value"], object: ["align", "archive", "border", "classid", "codebase", "codetype", "data", "declare", "form", "height", "hspace", "name", "standby", "type", "typemustmatch", "usemap", "vspace", "width"], ol: ["compact", "reversed", "start", "type"], optgroup: ["disabled", "label"], option: ["disabled", "label", "selected", "value"], output: ["for", "form", "name"], p: ["align"], param: ["name", "type", "value", "valuetype"], pre: ["width"], progress: ["max", "value"], q: ["cite"], script: ["async", "charset", "crossorigin", "defer", "integrity", "language", "nomodule", "referrerpolicy", "src", "type"], select: ["autocomplete", "disabled", "form", "multiple", "name", "required", "size"], slot: ["name"], source: ["height", "media", "sizes", "src", "srcset", "type", "width"], style: ["media", "type"], table: ["align", "bgcolor", "border", "cellpadding", "cellspacing", "frame", "rules", "summary", "width"], tbody: ["align", "char", "charoff", "valign"], td: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], textarea: ["autocomplete", "cols", "dirname", "disabled", "form", "maxlength", "minlength", "name", "placeholder", "readonly", "required", "rows", "wrap"], tfoot: ["align", "char", "charoff", "valign"], th: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], thead: ["align", "char", "charoff", "valign"], time: ["datetime"], tr: ["align", "bgcolor", "char", "charoff", "valign"], track: ["default", "kind", "label", "src", "srclang"], ul: ["compact", "type"], video: ["autoplay", "controls", "crossorigin", "height", "loop", "muted", "playsinline", "poster", "preload", "src", "width"] } };
      } }), pr = S({ "src/language-html/utils/map-object.js"(e, t) {
        R();
        function a(o, p) {
          let r = /* @__PURE__ */ Object.create(null);
          for (let [i, m] of Object.entries(o))
            r[i] = p(m, i);
          return r;
        }
        t.exports = a;
      } }), hr = S({ "src/language-html/utils/html-elements-attributes.js"(e, t) {
        R();
        var { htmlElementAttributes: a } = cr(), o = pr(), p = $u(), r = o(a, p);
        t.exports = r;
      } }), dr = S({ "src/language-html/utils/is-unknown-namespace.js"(e, t) {
        R();
        function a(o) {
          return o.type === "element" && !o.hasExplicitNamespace && !["html", "svg"].includes(o.namespace);
        }
        t.exports = a;
      } }), Cr = S({ "src/language-html/pragma.js"(e, t) {
        R();
        function a(p) {
          return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(p);
        }
        function o(p) {
          return `<!-- @format -->

` + p.replace(/^\s*\n/, "");
        }
        t.exports = { hasPragma: a, insertPragma: o };
      } }), Er = S({ "src/language-html/ast.js"(e, t) {
        R();
        var a = { attrs: !0, children: !0 }, o = /* @__PURE__ */ new Set(["parent"]), p = class {
          constructor() {
            let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            for (let m of /* @__PURE__ */ new Set([...o, ...Object.keys(i)]))
              this.setProperty(m, i[m]);
          }
          setProperty(i, m) {
            if (this[i] !== m) {
              if (i in a && (m = m.map((f) => this.createChild(f))), !o.has(i)) {
                this[i] = m;
                return;
              }
              Object.defineProperty(this, i, { value: m, enumerable: !1, configurable: !0 });
            }
          }
          map(i) {
            let m;
            for (let f in a) {
              let L = this[f];
              if (L) {
                let s = r(L, (D) => D.map(i));
                m !== L && (m || (m = new p({ parent: this.parent })), m.setProperty(f, s));
              }
            }
            if (m)
              for (let f in this)
                f in a || (m[f] = this[f]);
            return i(m || this);
          }
          walk(i) {
            for (let m in a) {
              let f = this[m];
              if (f)
                for (let L = 0; L < f.length; L++)
                  f[L].walk(i);
            }
            i(this);
          }
          createChild(i) {
            let m = i instanceof p ? i.clone() : new p(i);
            return m.setProperty("parent", this), m;
          }
          insertChildBefore(i, m) {
            this.children.splice(this.children.indexOf(i), 0, this.createChild(m));
          }
          removeChild(i) {
            this.children.splice(this.children.indexOf(i), 1);
          }
          replaceChild(i, m) {
            this.children[this.children.indexOf(i)] = this.createChild(m);
          }
          clone() {
            return new p(this);
          }
          get firstChild() {
            var i;
            return (i = this.children) === null || i === void 0 ? void 0 : i[0];
          }
          get lastChild() {
            var i;
            return (i = this.children) === null || i === void 0 ? void 0 : i[this.children.length - 1];
          }
          get prev() {
            var i;
            return (i = this.parent) === null || i === void 0 ? void 0 : i.children[this.parent.children.indexOf(this) - 1];
          }
          get next() {
            var i;
            return (i = this.parent) === null || i === void 0 ? void 0 : i.children[this.parent.children.indexOf(this) + 1];
          }
          get rawName() {
            return this.hasExplicitNamespace ? this.fullName : this.name;
          }
          get fullName() {
            return this.namespace ? this.namespace + ":" + this.name : this.name;
          }
          get attrMap() {
            return Object.fromEntries(this.attrs.map((i) => [i.fullName, i.value]));
          }
        };
        function r(i, m) {
          let f = i.map(m);
          return f.some((L, s) => L !== i[s]) ? f : i;
        }
        t.exports = { Node: p };
      } }), mr = S({ "src/language-html/conditional-comment.js"(e, t) {
        R();
        var { ParseSourceSpan: a } = _e(), o = [{ regex: /^(\[if([^\]]*)]>)(.*?)<!\s*\[endif]$/s, parse: r }, { regex: /^\[if([^\]]*)]><!$/, parse: i }, { regex: /^<!\s*\[endif]$/, parse: m }];
        function p(f, L) {
          if (f.value)
            for (let { regex: s, parse: D } of o) {
              let E = f.value.match(s);
              if (E)
                return D(f, L, E);
            }
          return null;
        }
        function r(f, L, s) {
          let [, D, E, v] = s, F = 4 + D.length, T = f.sourceSpan.start.moveBy(F), $ = T.moveBy(v.length), [X, O] = (() => {
            try {
              return [!0, L(v, T).children];
            } catch {
              return [!1, [{ type: "text", value: v, sourceSpan: new a(T, $) }]];
            }
          })();
          return { type: "ieConditionalComment", complete: X, children: O, condition: E.trim().replace(/\s+/g, " "), sourceSpan: f.sourceSpan, startSourceSpan: new a(f.sourceSpan.start, T), endSourceSpan: new a($, f.sourceSpan.end) };
        }
        function i(f, L, s) {
          let [, D] = s;
          return { type: "ieConditionalStartComment", condition: D.trim().replace(/\s+/g, " "), sourceSpan: f.sourceSpan };
        }
        function m(f) {
          return { type: "ieConditionalEndComment", sourceSpan: f.sourceSpan };
        }
        t.exports = { parseIeConditionalComment: p };
      } }), fr = S({ "src/language-html/loc.js"(e, t) {
        R();
        function a(p) {
          return p.sourceSpan.start.offset;
        }
        function o(p) {
          return p.sourceSpan.end.offset;
        }
        t.exports = { locStart: a, locEnd: o };
      } }), Qe = S({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/tags.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 }), function(m) {
          m[m.RAW_TEXT = 0] = "RAW_TEXT", m[m.ESCAPABLE_RAW_TEXT = 1] = "ESCAPABLE_RAW_TEXT", m[m.PARSABLE_DATA = 2] = "PARSABLE_DATA";
        }(e.TagContentType || (e.TagContentType = {}));
        function t(m) {
          if (m[0] != ":")
            return [null, m];
          let f = m.indexOf(":", 1);
          if (f == -1)
            throw new Error(`Unsupported format "${m}" expecting ":namespace:name"`);
          return [m.slice(1, f), m.slice(f + 1)];
        }
        e.splitNsName = t;
        function a(m) {
          return t(m)[1] === "ng-container";
        }
        e.isNgContainer = a;
        function o(m) {
          return t(m)[1] === "ng-content";
        }
        e.isNgContent = o;
        function p(m) {
          return t(m)[1] === "ng-template";
        }
        e.isNgTemplate = p;
        function r(m) {
          return m === null ? null : t(m)[0];
        }
        e.getNsPrefix = r;
        function i(m, f) {
          return m ? `:${m}:${f}` : f;
        }
        e.mergeNsAndName = i, e.NAMED_ENTITIES = { Aacute: "Á", aacute: "á", Abreve: "Ă", abreve: "ă", ac: "∾", acd: "∿", acE: "∾̳", Acirc: "Â", acirc: "â", acute: "´", Acy: "А", acy: "а", AElig: "Æ", aelig: "æ", af: "⁡", Afr: "𝔄", afr: "𝔞", Agrave: "À", agrave: "à", alefsym: "ℵ", aleph: "ℵ", Alpha: "Α", alpha: "α", Amacr: "Ā", amacr: "ā", amalg: "⨿", AMP: "&", amp: "&", And: "⩓", and: "∧", andand: "⩕", andd: "⩜", andslope: "⩘", andv: "⩚", ang: "∠", ange: "⦤", angle: "∠", angmsd: "∡", angmsdaa: "⦨", angmsdab: "⦩", angmsdac: "⦪", angmsdad: "⦫", angmsdae: "⦬", angmsdaf: "⦭", angmsdag: "⦮", angmsdah: "⦯", angrt: "∟", angrtvb: "⊾", angrtvbd: "⦝", angsph: "∢", angst: "Å", angzarr: "⍼", Aogon: "Ą", aogon: "ą", Aopf: "𝔸", aopf: "𝕒", ap: "≈", apacir: "⩯", apE: "⩰", ape: "≊", apid: "≋", apos: "'", ApplyFunction: "⁡", approx: "≈", approxeq: "≊", Aring: "Å", aring: "å", Ascr: "𝒜", ascr: "𝒶", Assign: "≔", ast: "*", asymp: "≈", asympeq: "≍", Atilde: "Ã", atilde: "ã", Auml: "Ä", auml: "ä", awconint: "∳", awint: "⨑", backcong: "≌", backepsilon: "϶", backprime: "‵", backsim: "∽", backsimeq: "⋍", Backslash: "∖", Barv: "⫧", barvee: "⊽", Barwed: "⌆", barwed: "⌅", barwedge: "⌅", bbrk: "⎵", bbrktbrk: "⎶", bcong: "≌", Bcy: "Б", bcy: "б", bdquo: "„", becaus: "∵", Because: "∵", because: "∵", bemptyv: "⦰", bepsi: "϶", bernou: "ℬ", Bernoullis: "ℬ", Beta: "Β", beta: "β", beth: "ℶ", between: "≬", Bfr: "𝔅", bfr: "𝔟", bigcap: "⋂", bigcirc: "◯", bigcup: "⋃", bigodot: "⨀", bigoplus: "⨁", bigotimes: "⨂", bigsqcup: "⨆", bigstar: "★", bigtriangledown: "▽", bigtriangleup: "△", biguplus: "⨄", bigvee: "⋁", bigwedge: "⋀", bkarow: "⤍", blacklozenge: "⧫", blacksquare: "▪", blacktriangle: "▴", blacktriangledown: "▾", blacktriangleleft: "◂", blacktriangleright: "▸", blank: "␣", blk12: "▒", blk14: "░", blk34: "▓", block: "█", bne: "=⃥", bnequiv: "≡⃥", bNot: "⫭", bnot: "⌐", Bopf: "𝔹", bopf: "𝕓", bot: "⊥", bottom: "⊥", bowtie: "⋈", boxbox: "⧉", boxDL: "╗", boxDl: "╖", boxdL: "╕", boxdl: "┐", boxDR: "╔", boxDr: "╓", boxdR: "╒", boxdr: "┌", boxH: "═", boxh: "─", boxHD: "╦", boxHd: "╤", boxhD: "╥", boxhd: "┬", boxHU: "╩", boxHu: "╧", boxhU: "╨", boxhu: "┴", boxminus: "⊟", boxplus: "⊞", boxtimes: "⊠", boxUL: "╝", boxUl: "╜", boxuL: "╛", boxul: "┘", boxUR: "╚", boxUr: "╙", boxuR: "╘", boxur: "└", boxV: "║", boxv: "│", boxVH: "╬", boxVh: "╫", boxvH: "╪", boxvh: "┼", boxVL: "╣", boxVl: "╢", boxvL: "╡", boxvl: "┤", boxVR: "╠", boxVr: "╟", boxvR: "╞", boxvr: "├", bprime: "‵", Breve: "˘", breve: "˘", brvbar: "¦", Bscr: "ℬ", bscr: "𝒷", bsemi: "⁏", bsim: "∽", bsime: "⋍", bsol: "\\", bsolb: "⧅", bsolhsub: "⟈", bull: "•", bullet: "•", bump: "≎", bumpE: "⪮", bumpe: "≏", Bumpeq: "≎", bumpeq: "≏", Cacute: "Ć", cacute: "ć", Cap: "⋒", cap: "∩", capand: "⩄", capbrcup: "⩉", capcap: "⩋", capcup: "⩇", capdot: "⩀", CapitalDifferentialD: "ⅅ", caps: "∩︀", caret: "⁁", caron: "ˇ", Cayleys: "ℭ", ccaps: "⩍", Ccaron: "Č", ccaron: "č", Ccedil: "Ç", ccedil: "ç", Ccirc: "Ĉ", ccirc: "ĉ", Cconint: "∰", ccups: "⩌", ccupssm: "⩐", Cdot: "Ċ", cdot: "ċ", cedil: "¸", Cedilla: "¸", cemptyv: "⦲", cent: "¢", CenterDot: "·", centerdot: "·", Cfr: "ℭ", cfr: "𝔠", CHcy: "Ч", chcy: "ч", check: "✓", checkmark: "✓", Chi: "Χ", chi: "χ", cir: "○", circ: "ˆ", circeq: "≗", circlearrowleft: "↺", circlearrowright: "↻", circledast: "⊛", circledcirc: "⊚", circleddash: "⊝", CircleDot: "⊙", circledR: "®", circledS: "Ⓢ", CircleMinus: "⊖", CirclePlus: "⊕", CircleTimes: "⊗", cirE: "⧃", cire: "≗", cirfnint: "⨐", cirmid: "⫯", cirscir: "⧂", ClockwiseContourIntegral: "∲", CloseCurlyDoubleQuote: "”", CloseCurlyQuote: "’", clubs: "♣", clubsuit: "♣", Colon: "∷", colon: ":", Colone: "⩴", colone: "≔", coloneq: "≔", comma: ",", commat: "@", comp: "∁", compfn: "∘", complement: "∁", complexes: "ℂ", cong: "≅", congdot: "⩭", Congruent: "≡", Conint: "∯", conint: "∮", ContourIntegral: "∮", Copf: "ℂ", copf: "𝕔", coprod: "∐", Coproduct: "∐", COPY: "©", copy: "©", copysr: "℗", CounterClockwiseContourIntegral: "∳", crarr: "↵", Cross: "⨯", cross: "✗", Cscr: "𝒞", cscr: "𝒸", csub: "⫏", csube: "⫑", csup: "⫐", csupe: "⫒", ctdot: "⋯", cudarrl: "⤸", cudarrr: "⤵", cuepr: "⋞", cuesc: "⋟", cularr: "↶", cularrp: "⤽", Cup: "⋓", cup: "∪", cupbrcap: "⩈", CupCap: "≍", cupcap: "⩆", cupcup: "⩊", cupdot: "⊍", cupor: "⩅", cups: "∪︀", curarr: "↷", curarrm: "⤼", curlyeqprec: "⋞", curlyeqsucc: "⋟", curlyvee: "⋎", curlywedge: "⋏", curren: "¤", curvearrowleft: "↶", curvearrowright: "↷", cuvee: "⋎", cuwed: "⋏", cwconint: "∲", cwint: "∱", cylcty: "⌭", Dagger: "‡", dagger: "†", daleth: "ℸ", Darr: "↡", dArr: "⇓", darr: "↓", dash: "‐", Dashv: "⫤", dashv: "⊣", dbkarow: "⤏", dblac: "˝", Dcaron: "Ď", dcaron: "ď", Dcy: "Д", dcy: "д", DD: "ⅅ", dd: "ⅆ", ddagger: "‡", ddarr: "⇊", DDotrahd: "⤑", ddotseq: "⩷", deg: "°", Del: "∇", Delta: "Δ", delta: "δ", demptyv: "⦱", dfisht: "⥿", Dfr: "𝔇", dfr: "𝔡", dHar: "⥥", dharl: "⇃", dharr: "⇂", DiacriticalAcute: "´", DiacriticalDot: "˙", DiacriticalDoubleAcute: "˝", DiacriticalGrave: "`", DiacriticalTilde: "˜", diam: "⋄", Diamond: "⋄", diamond: "⋄", diamondsuit: "♦", diams: "♦", die: "¨", DifferentialD: "ⅆ", digamma: "ϝ", disin: "⋲", div: "÷", divide: "÷", divideontimes: "⋇", divonx: "⋇", DJcy: "Ђ", djcy: "ђ", dlcorn: "⌞", dlcrop: "⌍", dollar: "$", Dopf: "𝔻", dopf: "𝕕", Dot: "¨", dot: "˙", DotDot: "⃜", doteq: "≐", doteqdot: "≑", DotEqual: "≐", dotminus: "∸", dotplus: "∔", dotsquare: "⊡", doublebarwedge: "⌆", DoubleContourIntegral: "∯", DoubleDot: "¨", DoubleDownArrow: "⇓", DoubleLeftArrow: "⇐", DoubleLeftRightArrow: "⇔", DoubleLeftTee: "⫤", DoubleLongLeftArrow: "⟸", DoubleLongLeftRightArrow: "⟺", DoubleLongRightArrow: "⟹", DoubleRightArrow: "⇒", DoubleRightTee: "⊨", DoubleUpArrow: "⇑", DoubleUpDownArrow: "⇕", DoubleVerticalBar: "∥", DownArrow: "↓", Downarrow: "⇓", downarrow: "↓", DownArrowBar: "⤓", DownArrowUpArrow: "⇵", DownBreve: "̑", downdownarrows: "⇊", downharpoonleft: "⇃", downharpoonright: "⇂", DownLeftRightVector: "⥐", DownLeftTeeVector: "⥞", DownLeftVector: "↽", DownLeftVectorBar: "⥖", DownRightTeeVector: "⥟", DownRightVector: "⇁", DownRightVectorBar: "⥗", DownTee: "⊤", DownTeeArrow: "↧", drbkarow: "⤐", drcorn: "⌟", drcrop: "⌌", Dscr: "𝒟", dscr: "𝒹", DScy: "Ѕ", dscy: "ѕ", dsol: "⧶", Dstrok: "Đ", dstrok: "đ", dtdot: "⋱", dtri: "▿", dtrif: "▾", duarr: "⇵", duhar: "⥯", dwangle: "⦦", DZcy: "Џ", dzcy: "џ", dzigrarr: "⟿", Eacute: "É", eacute: "é", easter: "⩮", Ecaron: "Ě", ecaron: "ě", ecir: "≖", Ecirc: "Ê", ecirc: "ê", ecolon: "≕", Ecy: "Э", ecy: "э", eDDot: "⩷", Edot: "Ė", eDot: "≑", edot: "ė", ee: "ⅇ", efDot: "≒", Efr: "𝔈", efr: "𝔢", eg: "⪚", Egrave: "È", egrave: "è", egs: "⪖", egsdot: "⪘", el: "⪙", Element: "∈", elinters: "⏧", ell: "ℓ", els: "⪕", elsdot: "⪗", Emacr: "Ē", emacr: "ē", empty: "∅", emptyset: "∅", EmptySmallSquare: "◻", emptyv: "∅", EmptyVerySmallSquare: "▫", emsp: " ", emsp13: " ", emsp14: " ", ENG: "Ŋ", eng: "ŋ", ensp: " ", Eogon: "Ę", eogon: "ę", Eopf: "𝔼", eopf: "𝕖", epar: "⋕", eparsl: "⧣", eplus: "⩱", epsi: "ε", Epsilon: "Ε", epsilon: "ε", epsiv: "ϵ", eqcirc: "≖", eqcolon: "≕", eqsim: "≂", eqslantgtr: "⪖", eqslantless: "⪕", Equal: "⩵", equals: "=", EqualTilde: "≂", equest: "≟", Equilibrium: "⇌", equiv: "≡", equivDD: "⩸", eqvparsl: "⧥", erarr: "⥱", erDot: "≓", Escr: "ℰ", escr: "ℯ", esdot: "≐", Esim: "⩳", esim: "≂", Eta: "Η", eta: "η", ETH: "Ð", eth: "ð", Euml: "Ë", euml: "ë", euro: "€", excl: "!", exist: "∃", Exists: "∃", expectation: "ℰ", ExponentialE: "ⅇ", exponentiale: "ⅇ", fallingdotseq: "≒", Fcy: "Ф", fcy: "ф", female: "♀", ffilig: "ﬃ", fflig: "ﬀ", ffllig: "ﬄ", Ffr: "𝔉", ffr: "𝔣", filig: "ﬁ", FilledSmallSquare: "◼", FilledVerySmallSquare: "▪", fjlig: "fj", flat: "♭", fllig: "ﬂ", fltns: "▱", fnof: "ƒ", Fopf: "𝔽", fopf: "𝕗", ForAll: "∀", forall: "∀", fork: "⋔", forkv: "⫙", Fouriertrf: "ℱ", fpartint: "⨍", frac12: "½", frac13: "⅓", frac14: "¼", frac15: "⅕", frac16: "⅙", frac18: "⅛", frac23: "⅔", frac25: "⅖", frac34: "¾", frac35: "⅗", frac38: "⅜", frac45: "⅘", frac56: "⅚", frac58: "⅝", frac78: "⅞", frasl: "⁄", frown: "⌢", Fscr: "ℱ", fscr: "𝒻", gacute: "ǵ", Gamma: "Γ", gamma: "γ", Gammad: "Ϝ", gammad: "ϝ", gap: "⪆", Gbreve: "Ğ", gbreve: "ğ", Gcedil: "Ģ", Gcirc: "Ĝ", gcirc: "ĝ", Gcy: "Г", gcy: "г", Gdot: "Ġ", gdot: "ġ", gE: "≧", ge: "≥", gEl: "⪌", gel: "⋛", geq: "≥", geqq: "≧", geqslant: "⩾", ges: "⩾", gescc: "⪩", gesdot: "⪀", gesdoto: "⪂", gesdotol: "⪄", gesl: "⋛︀", gesles: "⪔", Gfr: "𝔊", gfr: "𝔤", Gg: "⋙", gg: "≫", ggg: "⋙", gimel: "ℷ", GJcy: "Ѓ", gjcy: "ѓ", gl: "≷", gla: "⪥", glE: "⪒", glj: "⪤", gnap: "⪊", gnapprox: "⪊", gnE: "≩", gne: "⪈", gneq: "⪈", gneqq: "≩", gnsim: "⋧", Gopf: "𝔾", gopf: "𝕘", grave: "`", GreaterEqual: "≥", GreaterEqualLess: "⋛", GreaterFullEqual: "≧", GreaterGreater: "⪢", GreaterLess: "≷", GreaterSlantEqual: "⩾", GreaterTilde: "≳", Gscr: "𝒢", gscr: "ℊ", gsim: "≳", gsime: "⪎", gsiml: "⪐", GT: ">", Gt: "≫", gt: ">", gtcc: "⪧", gtcir: "⩺", gtdot: "⋗", gtlPar: "⦕", gtquest: "⩼", gtrapprox: "⪆", gtrarr: "⥸", gtrdot: "⋗", gtreqless: "⋛", gtreqqless: "⪌", gtrless: "≷", gtrsim: "≳", gvertneqq: "≩︀", gvnE: "≩︀", Hacek: "ˇ", hairsp: " ", half: "½", hamilt: "ℋ", HARDcy: "Ъ", hardcy: "ъ", hArr: "⇔", harr: "↔", harrcir: "⥈", harrw: "↭", Hat: "^", hbar: "ℏ", Hcirc: "Ĥ", hcirc: "ĥ", hearts: "♥", heartsuit: "♥", hellip: "…", hercon: "⊹", Hfr: "ℌ", hfr: "𝔥", HilbertSpace: "ℋ", hksearow: "⤥", hkswarow: "⤦", hoarr: "⇿", homtht: "∻", hookleftarrow: "↩", hookrightarrow: "↪", Hopf: "ℍ", hopf: "𝕙", horbar: "―", HorizontalLine: "─", Hscr: "ℋ", hscr: "𝒽", hslash: "ℏ", Hstrok: "Ħ", hstrok: "ħ", HumpDownHump: "≎", HumpEqual: "≏", hybull: "⁃", hyphen: "‐", Iacute: "Í", iacute: "í", ic: "⁣", Icirc: "Î", icirc: "î", Icy: "И", icy: "и", Idot: "İ", IEcy: "Е", iecy: "е", iexcl: "¡", iff: "⇔", Ifr: "ℑ", ifr: "𝔦", Igrave: "Ì", igrave: "ì", ii: "ⅈ", iiiint: "⨌", iiint: "∭", iinfin: "⧜", iiota: "℩", IJlig: "Ĳ", ijlig: "ĳ", Im: "ℑ", Imacr: "Ī", imacr: "ī", image: "ℑ", ImaginaryI: "ⅈ", imagline: "ℐ", imagpart: "ℑ", imath: "ı", imof: "⊷", imped: "Ƶ", Implies: "⇒", in: "∈", incare: "℅", infin: "∞", infintie: "⧝", inodot: "ı", Int: "∬", int: "∫", intcal: "⊺", integers: "ℤ", Integral: "∫", intercal: "⊺", Intersection: "⋂", intlarhk: "⨗", intprod: "⨼", InvisibleComma: "⁣", InvisibleTimes: "⁢", IOcy: "Ё", iocy: "ё", Iogon: "Į", iogon: "į", Iopf: "𝕀", iopf: "𝕚", Iota: "Ι", iota: "ι", iprod: "⨼", iquest: "¿", Iscr: "ℐ", iscr: "𝒾", isin: "∈", isindot: "⋵", isinE: "⋹", isins: "⋴", isinsv: "⋳", isinv: "∈", it: "⁢", Itilde: "Ĩ", itilde: "ĩ", Iukcy: "І", iukcy: "і", Iuml: "Ï", iuml: "ï", Jcirc: "Ĵ", jcirc: "ĵ", Jcy: "Й", jcy: "й", Jfr: "𝔍", jfr: "𝔧", jmath: "ȷ", Jopf: "𝕁", jopf: "𝕛", Jscr: "𝒥", jscr: "𝒿", Jsercy: "Ј", jsercy: "ј", Jukcy: "Є", jukcy: "є", Kappa: "Κ", kappa: "κ", kappav: "ϰ", Kcedil: "Ķ", kcedil: "ķ", Kcy: "К", kcy: "к", Kfr: "𝔎", kfr: "𝔨", kgreen: "ĸ", KHcy: "Х", khcy: "х", KJcy: "Ќ", kjcy: "ќ", Kopf: "𝕂", kopf: "𝕜", Kscr: "𝒦", kscr: "𝓀", lAarr: "⇚", Lacute: "Ĺ", lacute: "ĺ", laemptyv: "⦴", lagran: "ℒ", Lambda: "Λ", lambda: "λ", Lang: "⟪", lang: "⟨", langd: "⦑", langle: "⟨", lap: "⪅", Laplacetrf: "ℒ", laquo: "«", Larr: "↞", lArr: "⇐", larr: "←", larrb: "⇤", larrbfs: "⤟", larrfs: "⤝", larrhk: "↩", larrlp: "↫", larrpl: "⤹", larrsim: "⥳", larrtl: "↢", lat: "⪫", lAtail: "⤛", latail: "⤙", late: "⪭", lates: "⪭︀", lBarr: "⤎", lbarr: "⤌", lbbrk: "❲", lbrace: "{", lbrack: "[", lbrke: "⦋", lbrksld: "⦏", lbrkslu: "⦍", Lcaron: "Ľ", lcaron: "ľ", Lcedil: "Ļ", lcedil: "ļ", lceil: "⌈", lcub: "{", Lcy: "Л", lcy: "л", ldca: "⤶", ldquo: "“", ldquor: "„", ldrdhar: "⥧", ldrushar: "⥋", ldsh: "↲", lE: "≦", le: "≤", LeftAngleBracket: "⟨", LeftArrow: "←", Leftarrow: "⇐", leftarrow: "←", LeftArrowBar: "⇤", LeftArrowRightArrow: "⇆", leftarrowtail: "↢", LeftCeiling: "⌈", LeftDoubleBracket: "⟦", LeftDownTeeVector: "⥡", LeftDownVector: "⇃", LeftDownVectorBar: "⥙", LeftFloor: "⌊", leftharpoondown: "↽", leftharpoonup: "↼", leftleftarrows: "⇇", LeftRightArrow: "↔", Leftrightarrow: "⇔", leftrightarrow: "↔", leftrightarrows: "⇆", leftrightharpoons: "⇋", leftrightsquigarrow: "↭", LeftRightVector: "⥎", LeftTee: "⊣", LeftTeeArrow: "↤", LeftTeeVector: "⥚", leftthreetimes: "⋋", LeftTriangle: "⊲", LeftTriangleBar: "⧏", LeftTriangleEqual: "⊴", LeftUpDownVector: "⥑", LeftUpTeeVector: "⥠", LeftUpVector: "↿", LeftUpVectorBar: "⥘", LeftVector: "↼", LeftVectorBar: "⥒", lEg: "⪋", leg: "⋚", leq: "≤", leqq: "≦", leqslant: "⩽", les: "⩽", lescc: "⪨", lesdot: "⩿", lesdoto: "⪁", lesdotor: "⪃", lesg: "⋚︀", lesges: "⪓", lessapprox: "⪅", lessdot: "⋖", lesseqgtr: "⋚", lesseqqgtr: "⪋", LessEqualGreater: "⋚", LessFullEqual: "≦", LessGreater: "≶", lessgtr: "≶", LessLess: "⪡", lesssim: "≲", LessSlantEqual: "⩽", LessTilde: "≲", lfisht: "⥼", lfloor: "⌊", Lfr: "𝔏", lfr: "𝔩", lg: "≶", lgE: "⪑", lHar: "⥢", lhard: "↽", lharu: "↼", lharul: "⥪", lhblk: "▄", LJcy: "Љ", ljcy: "љ", Ll: "⋘", ll: "≪", llarr: "⇇", llcorner: "⌞", Lleftarrow: "⇚", llhard: "⥫", lltri: "◺", Lmidot: "Ŀ", lmidot: "ŀ", lmoust: "⎰", lmoustache: "⎰", lnap: "⪉", lnapprox: "⪉", lnE: "≨", lne: "⪇", lneq: "⪇", lneqq: "≨", lnsim: "⋦", loang: "⟬", loarr: "⇽", lobrk: "⟦", LongLeftArrow: "⟵", Longleftarrow: "⟸", longleftarrow: "⟵", LongLeftRightArrow: "⟷", Longleftrightarrow: "⟺", longleftrightarrow: "⟷", longmapsto: "⟼", LongRightArrow: "⟶", Longrightarrow: "⟹", longrightarrow: "⟶", looparrowleft: "↫", looparrowright: "↬", lopar: "⦅", Lopf: "𝕃", lopf: "𝕝", loplus: "⨭", lotimes: "⨴", lowast: "∗", lowbar: "_", LowerLeftArrow: "↙", LowerRightArrow: "↘", loz: "◊", lozenge: "◊", lozf: "⧫", lpar: "(", lparlt: "⦓", lrarr: "⇆", lrcorner: "⌟", lrhar: "⇋", lrhard: "⥭", lrm: "‎", lrtri: "⊿", lsaquo: "‹", Lscr: "ℒ", lscr: "𝓁", Lsh: "↰", lsh: "↰", lsim: "≲", lsime: "⪍", lsimg: "⪏", lsqb: "[", lsquo: "‘", lsquor: "‚", Lstrok: "Ł", lstrok: "ł", LT: "<", Lt: "≪", lt: "<", ltcc: "⪦", ltcir: "⩹", ltdot: "⋖", lthree: "⋋", ltimes: "⋉", ltlarr: "⥶", ltquest: "⩻", ltri: "◃", ltrie: "⊴", ltrif: "◂", ltrPar: "⦖", lurdshar: "⥊", luruhar: "⥦", lvertneqq: "≨︀", lvnE: "≨︀", macr: "¯", male: "♂", malt: "✠", maltese: "✠", Map: "⤅", map: "↦", mapsto: "↦", mapstodown: "↧", mapstoleft: "↤", mapstoup: "↥", marker: "▮", mcomma: "⨩", Mcy: "М", mcy: "м", mdash: "—", mDDot: "∺", measuredangle: "∡", MediumSpace: " ", Mellintrf: "ℳ", Mfr: "𝔐", mfr: "𝔪", mho: "℧", micro: "µ", mid: "∣", midast: "*", midcir: "⫰", middot: "·", minus: "−", minusb: "⊟", minusd: "∸", minusdu: "⨪", MinusPlus: "∓", mlcp: "⫛", mldr: "…", mnplus: "∓", models: "⊧", Mopf: "𝕄", mopf: "𝕞", mp: "∓", Mscr: "ℳ", mscr: "𝓂", mstpos: "∾", Mu: "Μ", mu: "μ", multimap: "⊸", mumap: "⊸", nabla: "∇", Nacute: "Ń", nacute: "ń", nang: "∠⃒", nap: "≉", napE: "⩰̸", napid: "≋̸", napos: "ŉ", napprox: "≉", natur: "♮", natural: "♮", naturals: "ℕ", nbsp: " ", nbump: "≎̸", nbumpe: "≏̸", ncap: "⩃", Ncaron: "Ň", ncaron: "ň", Ncedil: "Ņ", ncedil: "ņ", ncong: "≇", ncongdot: "⩭̸", ncup: "⩂", Ncy: "Н", ncy: "н", ndash: "–", ne: "≠", nearhk: "⤤", neArr: "⇗", nearr: "↗", nearrow: "↗", nedot: "≐̸", NegativeMediumSpace: "​", NegativeThickSpace: "​", NegativeThinSpace: "​", NegativeVeryThinSpace: "​", nequiv: "≢", nesear: "⤨", nesim: "≂̸", NestedGreaterGreater: "≫", NestedLessLess: "≪", NewLine: `
`, nexist: "∄", nexists: "∄", Nfr: "𝔑", nfr: "𝔫", ngE: "≧̸", nge: "≱", ngeq: "≱", ngeqq: "≧̸", ngeqslant: "⩾̸", nges: "⩾̸", nGg: "⋙̸", ngsim: "≵", nGt: "≫⃒", ngt: "≯", ngtr: "≯", nGtv: "≫̸", nhArr: "⇎", nharr: "↮", nhpar: "⫲", ni: "∋", nis: "⋼", nisd: "⋺", niv: "∋", NJcy: "Њ", njcy: "њ", nlArr: "⇍", nlarr: "↚", nldr: "‥", nlE: "≦̸", nle: "≰", nLeftarrow: "⇍", nleftarrow: "↚", nLeftrightarrow: "⇎", nleftrightarrow: "↮", nleq: "≰", nleqq: "≦̸", nleqslant: "⩽̸", nles: "⩽̸", nless: "≮", nLl: "⋘̸", nlsim: "≴", nLt: "≪⃒", nlt: "≮", nltri: "⋪", nltrie: "⋬", nLtv: "≪̸", nmid: "∤", NoBreak: "⁠", NonBreakingSpace: " ", Nopf: "ℕ", nopf: "𝕟", Not: "⫬", not: "¬", NotCongruent: "≢", NotCupCap: "≭", NotDoubleVerticalBar: "∦", NotElement: "∉", NotEqual: "≠", NotEqualTilde: "≂̸", NotExists: "∄", NotGreater: "≯", NotGreaterEqual: "≱", NotGreaterFullEqual: "≧̸", NotGreaterGreater: "≫̸", NotGreaterLess: "≹", NotGreaterSlantEqual: "⩾̸", NotGreaterTilde: "≵", NotHumpDownHump: "≎̸", NotHumpEqual: "≏̸", notin: "∉", notindot: "⋵̸", notinE: "⋹̸", notinva: "∉", notinvb: "⋷", notinvc: "⋶", NotLeftTriangle: "⋪", NotLeftTriangleBar: "⧏̸", NotLeftTriangleEqual: "⋬", NotLess: "≮", NotLessEqual: "≰", NotLessGreater: "≸", NotLessLess: "≪̸", NotLessSlantEqual: "⩽̸", NotLessTilde: "≴", NotNestedGreaterGreater: "⪢̸", NotNestedLessLess: "⪡̸", notni: "∌", notniva: "∌", notnivb: "⋾", notnivc: "⋽", NotPrecedes: "⊀", NotPrecedesEqual: "⪯̸", NotPrecedesSlantEqual: "⋠", NotReverseElement: "∌", NotRightTriangle: "⋫", NotRightTriangleBar: "⧐̸", NotRightTriangleEqual: "⋭", NotSquareSubset: "⊏̸", NotSquareSubsetEqual: "⋢", NotSquareSuperset: "⊐̸", NotSquareSupersetEqual: "⋣", NotSubset: "⊂⃒", NotSubsetEqual: "⊈", NotSucceeds: "⊁", NotSucceedsEqual: "⪰̸", NotSucceedsSlantEqual: "⋡", NotSucceedsTilde: "≿̸", NotSuperset: "⊃⃒", NotSupersetEqual: "⊉", NotTilde: "≁", NotTildeEqual: "≄", NotTildeFullEqual: "≇", NotTildeTilde: "≉", NotVerticalBar: "∤", npar: "∦", nparallel: "∦", nparsl: "⫽⃥", npart: "∂̸", npolint: "⨔", npr: "⊀", nprcue: "⋠", npre: "⪯̸", nprec: "⊀", npreceq: "⪯̸", nrArr: "⇏", nrarr: "↛", nrarrc: "⤳̸", nrarrw: "↝̸", nRightarrow: "⇏", nrightarrow: "↛", nrtri: "⋫", nrtrie: "⋭", nsc: "⊁", nsccue: "⋡", nsce: "⪰̸", Nscr: "𝒩", nscr: "𝓃", nshortmid: "∤", nshortparallel: "∦", nsim: "≁", nsime: "≄", nsimeq: "≄", nsmid: "∤", nspar: "∦", nsqsube: "⋢", nsqsupe: "⋣", nsub: "⊄", nsubE: "⫅̸", nsube: "⊈", nsubset: "⊂⃒", nsubseteq: "⊈", nsubseteqq: "⫅̸", nsucc: "⊁", nsucceq: "⪰̸", nsup: "⊅", nsupE: "⫆̸", nsupe: "⊉", nsupset: "⊃⃒", nsupseteq: "⊉", nsupseteqq: "⫆̸", ntgl: "≹", Ntilde: "Ñ", ntilde: "ñ", ntlg: "≸", ntriangleleft: "⋪", ntrianglelefteq: "⋬", ntriangleright: "⋫", ntrianglerighteq: "⋭", Nu: "Ν", nu: "ν", num: "#", numero: "№", numsp: " ", nvap: "≍⃒", nVDash: "⊯", nVdash: "⊮", nvDash: "⊭", nvdash: "⊬", nvge: "≥⃒", nvgt: ">⃒", nvHarr: "⤄", nvinfin: "⧞", nvlArr: "⤂", nvle: "≤⃒", nvlt: "<⃒", nvltrie: "⊴⃒", nvrArr: "⤃", nvrtrie: "⊵⃒", nvsim: "∼⃒", nwarhk: "⤣", nwArr: "⇖", nwarr: "↖", nwarrow: "↖", nwnear: "⤧", Oacute: "Ó", oacute: "ó", oast: "⊛", ocir: "⊚", Ocirc: "Ô", ocirc: "ô", Ocy: "О", ocy: "о", odash: "⊝", Odblac: "Ő", odblac: "ő", odiv: "⨸", odot: "⊙", odsold: "⦼", OElig: "Œ", oelig: "œ", ofcir: "⦿", Ofr: "𝔒", ofr: "𝔬", ogon: "˛", Ograve: "Ò", ograve: "ò", ogt: "⧁", ohbar: "⦵", ohm: "Ω", oint: "∮", olarr: "↺", olcir: "⦾", olcross: "⦻", oline: "‾", olt: "⧀", Omacr: "Ō", omacr: "ō", Omega: "Ω", omega: "ω", Omicron: "Ο", omicron: "ο", omid: "⦶", ominus: "⊖", Oopf: "𝕆", oopf: "𝕠", opar: "⦷", OpenCurlyDoubleQuote: "“", OpenCurlyQuote: "‘", operp: "⦹", oplus: "⊕", Or: "⩔", or: "∨", orarr: "↻", ord: "⩝", order: "ℴ", orderof: "ℴ", ordf: "ª", ordm: "º", origof: "⊶", oror: "⩖", orslope: "⩗", orv: "⩛", oS: "Ⓢ", Oscr: "𝒪", oscr: "ℴ", Oslash: "Ø", oslash: "ø", osol: "⊘", Otilde: "Õ", otilde: "õ", Otimes: "⨷", otimes: "⊗", otimesas: "⨶", Ouml: "Ö", ouml: "ö", ovbar: "⌽", OverBar: "‾", OverBrace: "⏞", OverBracket: "⎴", OverParenthesis: "⏜", par: "∥", para: "¶", parallel: "∥", parsim: "⫳", parsl: "⫽", part: "∂", PartialD: "∂", Pcy: "П", pcy: "п", percnt: "%", period: ".", permil: "‰", perp: "⊥", pertenk: "‱", Pfr: "𝔓", pfr: "𝔭", Phi: "Φ", phi: "φ", phiv: "ϕ", phmmat: "ℳ", phone: "☎", Pi: "Π", pi: "π", pitchfork: "⋔", piv: "ϖ", planck: "ℏ", planckh: "ℎ", plankv: "ℏ", plus: "+", plusacir: "⨣", plusb: "⊞", pluscir: "⨢", plusdo: "∔", plusdu: "⨥", pluse: "⩲", PlusMinus: "±", plusmn: "±", plussim: "⨦", plustwo: "⨧", pm: "±", Poincareplane: "ℌ", pointint: "⨕", Popf: "ℙ", popf: "𝕡", pound: "£", Pr: "⪻", pr: "≺", prap: "⪷", prcue: "≼", prE: "⪳", pre: "⪯", prec: "≺", precapprox: "⪷", preccurlyeq: "≼", Precedes: "≺", PrecedesEqual: "⪯", PrecedesSlantEqual: "≼", PrecedesTilde: "≾", preceq: "⪯", precnapprox: "⪹", precneqq: "⪵", precnsim: "⋨", precsim: "≾", Prime: "″", prime: "′", primes: "ℙ", prnap: "⪹", prnE: "⪵", prnsim: "⋨", prod: "∏", Product: "∏", profalar: "⌮", profline: "⌒", profsurf: "⌓", prop: "∝", Proportion: "∷", Proportional: "∝", propto: "∝", prsim: "≾", prurel: "⊰", Pscr: "𝒫", pscr: "𝓅", Psi: "Ψ", psi: "ψ", puncsp: " ", Qfr: "𝔔", qfr: "𝔮", qint: "⨌", Qopf: "ℚ", qopf: "𝕢", qprime: "⁗", Qscr: "𝒬", qscr: "𝓆", quaternions: "ℍ", quatint: "⨖", quest: "?", questeq: "≟", QUOT: '"', quot: '"', rAarr: "⇛", race: "∽̱", Racute: "Ŕ", racute: "ŕ", radic: "√", raemptyv: "⦳", Rang: "⟫", rang: "⟩", rangd: "⦒", range: "⦥", rangle: "⟩", raquo: "»", Rarr: "↠", rArr: "⇒", rarr: "→", rarrap: "⥵", rarrb: "⇥", rarrbfs: "⤠", rarrc: "⤳", rarrfs: "⤞", rarrhk: "↪", rarrlp: "↬", rarrpl: "⥅", rarrsim: "⥴", Rarrtl: "⤖", rarrtl: "↣", rarrw: "↝", rAtail: "⤜", ratail: "⤚", ratio: "∶", rationals: "ℚ", RBarr: "⤐", rBarr: "⤏", rbarr: "⤍", rbbrk: "❳", rbrace: "}", rbrack: "]", rbrke: "⦌", rbrksld: "⦎", rbrkslu: "⦐", Rcaron: "Ř", rcaron: "ř", Rcedil: "Ŗ", rcedil: "ŗ", rceil: "⌉", rcub: "}", Rcy: "Р", rcy: "р", rdca: "⤷", rdldhar: "⥩", rdquo: "”", rdquor: "”", rdsh: "↳", Re: "ℜ", real: "ℜ", realine: "ℛ", realpart: "ℜ", reals: "ℝ", rect: "▭", REG: "®", reg: "®", ReverseElement: "∋", ReverseEquilibrium: "⇋", ReverseUpEquilibrium: "⥯", rfisht: "⥽", rfloor: "⌋", Rfr: "ℜ", rfr: "𝔯", rHar: "⥤", rhard: "⇁", rharu: "⇀", rharul: "⥬", Rho: "Ρ", rho: "ρ", rhov: "ϱ", RightAngleBracket: "⟩", RightArrow: "→", Rightarrow: "⇒", rightarrow: "→", RightArrowBar: "⇥", RightArrowLeftArrow: "⇄", rightarrowtail: "↣", RightCeiling: "⌉", RightDoubleBracket: "⟧", RightDownTeeVector: "⥝", RightDownVector: "⇂", RightDownVectorBar: "⥕", RightFloor: "⌋", rightharpoondown: "⇁", rightharpoonup: "⇀", rightleftarrows: "⇄", rightleftharpoons: "⇌", rightrightarrows: "⇉", rightsquigarrow: "↝", RightTee: "⊢", RightTeeArrow: "↦", RightTeeVector: "⥛", rightthreetimes: "⋌", RightTriangle: "⊳", RightTriangleBar: "⧐", RightTriangleEqual: "⊵", RightUpDownVector: "⥏", RightUpTeeVector: "⥜", RightUpVector: "↾", RightUpVectorBar: "⥔", RightVector: "⇀", RightVectorBar: "⥓", ring: "˚", risingdotseq: "≓", rlarr: "⇄", rlhar: "⇌", rlm: "‏", rmoust: "⎱", rmoustache: "⎱", rnmid: "⫮", roang: "⟭", roarr: "⇾", robrk: "⟧", ropar: "⦆", Ropf: "ℝ", ropf: "𝕣", roplus: "⨮", rotimes: "⨵", RoundImplies: "⥰", rpar: ")", rpargt: "⦔", rppolint: "⨒", rrarr: "⇉", Rrightarrow: "⇛", rsaquo: "›", Rscr: "ℛ", rscr: "𝓇", Rsh: "↱", rsh: "↱", rsqb: "]", rsquo: "’", rsquor: "’", rthree: "⋌", rtimes: "⋊", rtri: "▹", rtrie: "⊵", rtrif: "▸", rtriltri: "⧎", RuleDelayed: "⧴", ruluhar: "⥨", rx: "℞", Sacute: "Ś", sacute: "ś", sbquo: "‚", Sc: "⪼", sc: "≻", scap: "⪸", Scaron: "Š", scaron: "š", sccue: "≽", scE: "⪴", sce: "⪰", Scedil: "Ş", scedil: "ş", Scirc: "Ŝ", scirc: "ŝ", scnap: "⪺", scnE: "⪶", scnsim: "⋩", scpolint: "⨓", scsim: "≿", Scy: "С", scy: "с", sdot: "⋅", sdotb: "⊡", sdote: "⩦", searhk: "⤥", seArr: "⇘", searr: "↘", searrow: "↘", sect: "§", semi: ";", seswar: "⤩", setminus: "∖", setmn: "∖", sext: "✶", Sfr: "𝔖", sfr: "𝔰", sfrown: "⌢", sharp: "♯", SHCHcy: "Щ", shchcy: "щ", SHcy: "Ш", shcy: "ш", ShortDownArrow: "↓", ShortLeftArrow: "←", shortmid: "∣", shortparallel: "∥", ShortRightArrow: "→", ShortUpArrow: "↑", shy: "­", Sigma: "Σ", sigma: "σ", sigmaf: "ς", sigmav: "ς", sim: "∼", simdot: "⩪", sime: "≃", simeq: "≃", simg: "⪞", simgE: "⪠", siml: "⪝", simlE: "⪟", simne: "≆", simplus: "⨤", simrarr: "⥲", slarr: "←", SmallCircle: "∘", smallsetminus: "∖", smashp: "⨳", smeparsl: "⧤", smid: "∣", smile: "⌣", smt: "⪪", smte: "⪬", smtes: "⪬︀", SOFTcy: "Ь", softcy: "ь", sol: "/", solb: "⧄", solbar: "⌿", Sopf: "𝕊", sopf: "𝕤", spades: "♠", spadesuit: "♠", spar: "∥", sqcap: "⊓", sqcaps: "⊓︀", sqcup: "⊔", sqcups: "⊔︀", Sqrt: "√", sqsub: "⊏", sqsube: "⊑", sqsubset: "⊏", sqsubseteq: "⊑", sqsup: "⊐", sqsupe: "⊒", sqsupset: "⊐", sqsupseteq: "⊒", squ: "□", Square: "□", square: "□", SquareIntersection: "⊓", SquareSubset: "⊏", SquareSubsetEqual: "⊑", SquareSuperset: "⊐", SquareSupersetEqual: "⊒", SquareUnion: "⊔", squarf: "▪", squf: "▪", srarr: "→", Sscr: "𝒮", sscr: "𝓈", ssetmn: "∖", ssmile: "⌣", sstarf: "⋆", Star: "⋆", star: "☆", starf: "★", straightepsilon: "ϵ", straightphi: "ϕ", strns: "¯", Sub: "⋐", sub: "⊂", subdot: "⪽", subE: "⫅", sube: "⊆", subedot: "⫃", submult: "⫁", subnE: "⫋", subne: "⊊", subplus: "⪿", subrarr: "⥹", Subset: "⋐", subset: "⊂", subseteq: "⊆", subseteqq: "⫅", SubsetEqual: "⊆", subsetneq: "⊊", subsetneqq: "⫋", subsim: "⫇", subsub: "⫕", subsup: "⫓", succ: "≻", succapprox: "⪸", succcurlyeq: "≽", Succeeds: "≻", SucceedsEqual: "⪰", SucceedsSlantEqual: "≽", SucceedsTilde: "≿", succeq: "⪰", succnapprox: "⪺", succneqq: "⪶", succnsim: "⋩", succsim: "≿", SuchThat: "∋", Sum: "∑", sum: "∑", sung: "♪", Sup: "⋑", sup: "⊃", sup1: "¹", sup2: "²", sup3: "³", supdot: "⪾", supdsub: "⫘", supE: "⫆", supe: "⊇", supedot: "⫄", Superset: "⊃", SupersetEqual: "⊇", suphsol: "⟉", suphsub: "⫗", suplarr: "⥻", supmult: "⫂", supnE: "⫌", supne: "⊋", supplus: "⫀", Supset: "⋑", supset: "⊃", supseteq: "⊇", supseteqq: "⫆", supsetneq: "⊋", supsetneqq: "⫌", supsim: "⫈", supsub: "⫔", supsup: "⫖", swarhk: "⤦", swArr: "⇙", swarr: "↙", swarrow: "↙", swnwar: "⤪", szlig: "ß", Tab: "	", target: "⌖", Tau: "Τ", tau: "τ", tbrk: "⎴", Tcaron: "Ť", tcaron: "ť", Tcedil: "Ţ", tcedil: "ţ", Tcy: "Т", tcy: "т", tdot: "⃛", telrec: "⌕", Tfr: "𝔗", tfr: "𝔱", there4: "∴", Therefore: "∴", therefore: "∴", Theta: "Θ", theta: "θ", thetasym: "ϑ", thetav: "ϑ", thickapprox: "≈", thicksim: "∼", ThickSpace: "  ", thinsp: " ", ThinSpace: " ", thkap: "≈", thksim: "∼", THORN: "Þ", thorn: "þ", Tilde: "∼", tilde: "˜", TildeEqual: "≃", TildeFullEqual: "≅", TildeTilde: "≈", times: "×", timesb: "⊠", timesbar: "⨱", timesd: "⨰", tint: "∭", toea: "⤨", top: "⊤", topbot: "⌶", topcir: "⫱", Topf: "𝕋", topf: "𝕥", topfork: "⫚", tosa: "⤩", tprime: "‴", TRADE: "™", trade: "™", triangle: "▵", triangledown: "▿", triangleleft: "◃", trianglelefteq: "⊴", triangleq: "≜", triangleright: "▹", trianglerighteq: "⊵", tridot: "◬", trie: "≜", triminus: "⨺", TripleDot: "⃛", triplus: "⨹", trisb: "⧍", tritime: "⨻", trpezium: "⏢", Tscr: "𝒯", tscr: "𝓉", TScy: "Ц", tscy: "ц", TSHcy: "Ћ", tshcy: "ћ", Tstrok: "Ŧ", tstrok: "ŧ", twixt: "≬", twoheadleftarrow: "↞", twoheadrightarrow: "↠", Uacute: "Ú", uacute: "ú", Uarr: "↟", uArr: "⇑", uarr: "↑", Uarrocir: "⥉", Ubrcy: "Ў", ubrcy: "ў", Ubreve: "Ŭ", ubreve: "ŭ", Ucirc: "Û", ucirc: "û", Ucy: "У", ucy: "у", udarr: "⇅", Udblac: "Ű", udblac: "ű", udhar: "⥮", ufisht: "⥾", Ufr: "𝔘", ufr: "𝔲", Ugrave: "Ù", ugrave: "ù", uHar: "⥣", uharl: "↿", uharr: "↾", uhblk: "▀", ulcorn: "⌜", ulcorner: "⌜", ulcrop: "⌏", ultri: "◸", Umacr: "Ū", umacr: "ū", uml: "¨", UnderBar: "_", UnderBrace: "⏟", UnderBracket: "⎵", UnderParenthesis: "⏝", Union: "⋃", UnionPlus: "⊎", Uogon: "Ų", uogon: "ų", Uopf: "𝕌", uopf: "𝕦", UpArrow: "↑", Uparrow: "⇑", uparrow: "↑", UpArrowBar: "⤒", UpArrowDownArrow: "⇅", UpDownArrow: "↕", Updownarrow: "⇕", updownarrow: "↕", UpEquilibrium: "⥮", upharpoonleft: "↿", upharpoonright: "↾", uplus: "⊎", UpperLeftArrow: "↖", UpperRightArrow: "↗", Upsi: "ϒ", upsi: "υ", upsih: "ϒ", Upsilon: "Υ", upsilon: "υ", UpTee: "⊥", UpTeeArrow: "↥", upuparrows: "⇈", urcorn: "⌝", urcorner: "⌝", urcrop: "⌎", Uring: "Ů", uring: "ů", urtri: "◹", Uscr: "𝒰", uscr: "𝓊", utdot: "⋰", Utilde: "Ũ", utilde: "ũ", utri: "▵", utrif: "▴", uuarr: "⇈", Uuml: "Ü", uuml: "ü", uwangle: "⦧", vangrt: "⦜", varepsilon: "ϵ", varkappa: "ϰ", varnothing: "∅", varphi: "ϕ", varpi: "ϖ", varpropto: "∝", vArr: "⇕", varr: "↕", varrho: "ϱ", varsigma: "ς", varsubsetneq: "⊊︀", varsubsetneqq: "⫋︀", varsupsetneq: "⊋︀", varsupsetneqq: "⫌︀", vartheta: "ϑ", vartriangleleft: "⊲", vartriangleright: "⊳", Vbar: "⫫", vBar: "⫨", vBarv: "⫩", Vcy: "В", vcy: "в", VDash: "⊫", Vdash: "⊩", vDash: "⊨", vdash: "⊢", Vdashl: "⫦", Vee: "⋁", vee: "∨", veebar: "⊻", veeeq: "≚", vellip: "⋮", Verbar: "‖", verbar: "|", Vert: "‖", vert: "|", VerticalBar: "∣", VerticalLine: "|", VerticalSeparator: "❘", VerticalTilde: "≀", VeryThinSpace: " ", Vfr: "𝔙", vfr: "𝔳", vltri: "⊲", vnsub: "⊂⃒", vnsup: "⊃⃒", Vopf: "𝕍", vopf: "𝕧", vprop: "∝", vrtri: "⊳", Vscr: "𝒱", vscr: "𝓋", vsubnE: "⫋︀", vsubne: "⊊︀", vsupnE: "⫌︀", vsupne: "⊋︀", Vvdash: "⊪", vzigzag: "⦚", Wcirc: "Ŵ", wcirc: "ŵ", wedbar: "⩟", Wedge: "⋀", wedge: "∧", wedgeq: "≙", weierp: "℘", Wfr: "𝔚", wfr: "𝔴", Wopf: "𝕎", wopf: "𝕨", wp: "℘", wr: "≀", wreath: "≀", Wscr: "𝒲", wscr: "𝓌", xcap: "⋂", xcirc: "◯", xcup: "⋃", xdtri: "▽", Xfr: "𝔛", xfr: "𝔵", xhArr: "⟺", xharr: "⟷", Xi: "Ξ", xi: "ξ", xlArr: "⟸", xlarr: "⟵", xmap: "⟼", xnis: "⋻", xodot: "⨀", Xopf: "𝕏", xopf: "𝕩", xoplus: "⨁", xotime: "⨂", xrArr: "⟹", xrarr: "⟶", Xscr: "𝒳", xscr: "𝓍", xsqcup: "⨆", xuplus: "⨄", xutri: "△", xvee: "⋁", xwedge: "⋀", Yacute: "Ý", yacute: "ý", YAcy: "Я", yacy: "я", Ycirc: "Ŷ", ycirc: "ŷ", Ycy: "Ы", ycy: "ы", yen: "¥", Yfr: "𝔜", yfr: "𝔶", YIcy: "Ї", yicy: "ї", Yopf: "𝕐", yopf: "𝕪", Yscr: "𝒴", yscr: "𝓎", YUcy: "Ю", yucy: "ю", Yuml: "Ÿ", yuml: "ÿ", Zacute: "Ź", zacute: "ź", Zcaron: "Ž", zcaron: "ž", Zcy: "З", zcy: "з", Zdot: "Ż", zdot: "ż", zeetrf: "ℨ", ZeroWidthSpace: "​", Zeta: "Ζ", zeta: "ζ", Zfr: "ℨ", zfr: "𝔷", ZHcy: "Ж", zhcy: "ж", zigrarr: "⇝", Zopf: "ℤ", zopf: "𝕫", Zscr: "𝒵", zscr: "𝓏", zwj: "‍", zwnj: "‌" }, e.NGSP_UNICODE = "", e.NAMED_ENTITIES.ngsp = e.NGSP_UNICODE;
      } }), qu = S({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_tags.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = Qe(), a = class {
          constructor() {
            let { closedByChildren: i, implicitNamespacePrefix: m, contentType: f = t.TagContentType.PARSABLE_DATA, closedByParent: L = !1, isVoid: s = !1, ignoreFirstLf: D = !1 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            this.closedByChildren = {}, this.closedByParent = !1, this.canSelfClose = !1, i && i.length > 0 && i.forEach((E) => this.closedByChildren[E] = !0), this.isVoid = s, this.closedByParent = L || s, this.implicitNamespacePrefix = m || null, this.contentType = f, this.ignoreFirstLf = D;
          }
          isClosedByChild(i) {
            return this.isVoid || i.toLowerCase() in this.closedByChildren;
          }
        };
        e.HtmlTagDefinition = a;
        var o, p;
        function r(i) {
          return p || (o = new a(), p = { base: new a({ isVoid: !0 }), meta: new a({ isVoid: !0 }), area: new a({ isVoid: !0 }), embed: new a({ isVoid: !0 }), link: new a({ isVoid: !0 }), img: new a({ isVoid: !0 }), input: new a({ isVoid: !0 }), param: new a({ isVoid: !0 }), hr: new a({ isVoid: !0 }), br: new a({ isVoid: !0 }), source: new a({ isVoid: !0 }), track: new a({ isVoid: !0 }), wbr: new a({ isVoid: !0 }), p: new a({ closedByChildren: ["address", "article", "aside", "blockquote", "div", "dl", "fieldset", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "main", "nav", "ol", "p", "pre", "section", "table", "ul"], closedByParent: !0 }), thead: new a({ closedByChildren: ["tbody", "tfoot"] }), tbody: new a({ closedByChildren: ["tbody", "tfoot"], closedByParent: !0 }), tfoot: new a({ closedByChildren: ["tbody"], closedByParent: !0 }), tr: new a({ closedByChildren: ["tr"], closedByParent: !0 }), td: new a({ closedByChildren: ["td", "th"], closedByParent: !0 }), th: new a({ closedByChildren: ["td", "th"], closedByParent: !0 }), col: new a({ isVoid: !0 }), svg: new a({ implicitNamespacePrefix: "svg" }), math: new a({ implicitNamespacePrefix: "math" }), li: new a({ closedByChildren: ["li"], closedByParent: !0 }), dt: new a({ closedByChildren: ["dt", "dd"] }), dd: new a({ closedByChildren: ["dt", "dd"], closedByParent: !0 }), rb: new a({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: !0 }), rt: new a({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: !0 }), rtc: new a({ closedByChildren: ["rb", "rtc", "rp"], closedByParent: !0 }), rp: new a({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: !0 }), optgroup: new a({ closedByChildren: ["optgroup"], closedByParent: !0 }), option: new a({ closedByChildren: ["option", "optgroup"], closedByParent: !0 }), pre: new a({ ignoreFirstLf: !0 }), listing: new a({ ignoreFirstLf: !0 }), style: new a({ contentType: t.TagContentType.RAW_TEXT }), script: new a({ contentType: t.TagContentType.RAW_TEXT }), title: new a({ contentType: t.TagContentType.ESCAPABLE_RAW_TEXT }), textarea: new a({ contentType: t.TagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: !0 }) }), p[i] || o;
        }
        e.getHtmlTagDefinition = r;
      } }), gr = S({ "node_modules/angular-html-parser/lib/compiler/src/ast_path.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = class {
          constructor(a) {
            let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
            this.path = a, this.position = o;
          }
          get empty() {
            return !this.path || !this.path.length;
          }
          get head() {
            return this.path[0];
          }
          get tail() {
            return this.path[this.path.length - 1];
          }
          parentOf(a) {
            return a && this.path[this.path.indexOf(a) - 1];
          }
          childOf(a) {
            return this.path[this.path.indexOf(a) + 1];
          }
          first(a) {
            for (let o = this.path.length - 1; o >= 0; o--) {
              let p = this.path[o];
              if (p instanceof a)
                return p;
            }
          }
          push(a) {
            this.path.push(a);
          }
          pop() {
            return this.path.pop();
          }
        };
        e.AstPath = t;
      } }), Mu = S({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/ast.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = gr(), a = class {
          constructor(F, T, $) {
            this.value = F, this.sourceSpan = T, this.i18n = $, this.type = "text";
          }
          visit(F, T) {
            return F.visitText(this, T);
          }
        };
        e.Text = a;
        var o = class {
          constructor(F, T) {
            this.value = F, this.sourceSpan = T, this.type = "cdata";
          }
          visit(F, T) {
            return F.visitCdata(this, T);
          }
        };
        e.CDATA = o;
        var p = class {
          constructor(F, T, $, X, O, G) {
            this.switchValue = F, this.type = T, this.cases = $, this.sourceSpan = X, this.switchValueSourceSpan = O, this.i18n = G;
          }
          visit(F, T) {
            return F.visitExpansion(this, T);
          }
        };
        e.Expansion = p;
        var r = class {
          constructor(F, T, $, X, O) {
            this.value = F, this.expression = T, this.sourceSpan = $, this.valueSourceSpan = X, this.expSourceSpan = O;
          }
          visit(F, T) {
            return F.visitExpansionCase(this, T);
          }
        };
        e.ExpansionCase = r;
        var i = class {
          constructor(F, T, $) {
            let X = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, O = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, G = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
            this.name = F, this.value = T, this.sourceSpan = $, this.valueSpan = X, this.nameSpan = O, this.i18n = G, this.type = "attribute";
          }
          visit(F, T) {
            return F.visitAttribute(this, T);
          }
        };
        e.Attribute = i;
        var m = class {
          constructor(F, T, $, X) {
            let O = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, G = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, W = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, se = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
            this.name = F, this.attrs = T, this.children = $, this.sourceSpan = X, this.startSourceSpan = O, this.endSourceSpan = G, this.nameSpan = W, this.i18n = se, this.type = "element";
          }
          visit(F, T) {
            return F.visitElement(this, T);
          }
        };
        e.Element = m;
        var f = class {
          constructor(F, T) {
            this.value = F, this.sourceSpan = T, this.type = "comment";
          }
          visit(F, T) {
            return F.visitComment(this, T);
          }
        };
        e.Comment = f;
        var L = class {
          constructor(F, T) {
            this.value = F, this.sourceSpan = T, this.type = "docType";
          }
          visit(F, T) {
            return F.visitDocType(this, T);
          }
        };
        e.DocType = L;
        function s(F, T) {
          let $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, X = [], O = F.visit ? (G) => F.visit(G, $) || G.visit(F, $) : (G) => G.visit(F, $);
          return T.forEach((G) => {
            let W = O(G);
            W && X.push(W);
          }), X;
        }
        e.visitAll = s;
        var D = class {
          constructor() {
          }
          visitElement(F, T) {
            this.visitChildren(T, ($) => {
              $(F.attrs), $(F.children);
            });
          }
          visitAttribute(F, T) {
          }
          visitText(F, T) {
          }
          visitCdata(F, T) {
          }
          visitComment(F, T) {
          }
          visitDocType(F, T) {
          }
          visitExpansion(F, T) {
            return this.visitChildren(T, ($) => {
              $(F.cases);
            });
          }
          visitExpansionCase(F, T) {
          }
          visitChildren(F, T) {
            let $ = [], X = this;
            function O(G) {
              G && $.push(s(X, G, F));
            }
            return T(O), Array.prototype.concat.apply([], $);
          }
        };
        e.RecursiveVisitor = D;
        function E(F) {
          let T = F.sourceSpan.start.offset, $ = F.sourceSpan.end.offset;
          return F instanceof m && (F.endSourceSpan ? $ = F.endSourceSpan.end.offset : F.children && F.children.length && ($ = E(F.children[F.children.length - 1]).end)), { start: T, end: $ };
        }
        function v(F, T) {
          let $ = [], X = new class extends D {
            visit(O, G) {
              let W = E(O);
              if (W.start <= T && T < W.end)
                $.push(O);
              else
                return !0;
            }
          }();
          return s(X, F), new t.AstPath($, T);
        }
        e.findNode = v;
      } }), Fr = S({ "node_modules/angular-html-parser/lib/compiler/src/assertions.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        function t(p, r) {
          if (r != null) {
            if (!Array.isArray(r))
              throw new Error(`Expected '${p}' to be an array of strings.`);
            for (let i = 0; i < r.length; i += 1)
              if (typeof r[i] != "string")
                throw new Error(`Expected '${p}' to be an array of strings.`);
          }
        }
        e.assertArrayOfStrings = t;
        var a = [/^\s*$/, /[<>]/, /^[{}]$/, /&(#|[a-z])/i, /^\/\//];
        function o(p, r) {
          if (r != null && !(Array.isArray(r) && r.length == 2))
            throw new Error(`Expected '${p}' to be an array, [start, end].`);
          if (r != null) {
            let i = r[0], m = r[1];
            a.forEach((f) => {
              if (f.test(i) || f.test(m))
                throw new Error(`['${i}', '${m}'] contains unusable interpolation symbol.`);
            });
          }
        }
        e.assertInterpolationSymbols = o;
      } }), Ar = S({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/interpolation_config.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = Fr(), a = class {
          constructor(o, p) {
            this.start = o, this.end = p;
          }
          static fromArray(o) {
            return o ? (t.assertInterpolationSymbols("interpolation", o), new a(o[0], o[1])) : e.DEFAULT_INTERPOLATION_CONFIG;
          }
        };
        e.InterpolationConfig = a, e.DEFAULT_INTERPOLATION_CONFIG = new a("{{", "}}");
      } }), vr = S({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/lexer.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = De(), a = _e(), o = Ar(), p = Qe(), r;
        (function(u) {
          u[u.TAG_OPEN_START = 0] = "TAG_OPEN_START", u[u.TAG_OPEN_END = 1] = "TAG_OPEN_END", u[u.TAG_OPEN_END_VOID = 2] = "TAG_OPEN_END_VOID", u[u.TAG_CLOSE = 3] = "TAG_CLOSE", u[u.TEXT = 4] = "TEXT", u[u.ESCAPABLE_RAW_TEXT = 5] = "ESCAPABLE_RAW_TEXT", u[u.RAW_TEXT = 6] = "RAW_TEXT", u[u.COMMENT_START = 7] = "COMMENT_START", u[u.COMMENT_END = 8] = "COMMENT_END", u[u.CDATA_START = 9] = "CDATA_START", u[u.CDATA_END = 10] = "CDATA_END", u[u.ATTR_NAME = 11] = "ATTR_NAME", u[u.ATTR_QUOTE = 12] = "ATTR_QUOTE", u[u.ATTR_VALUE = 13] = "ATTR_VALUE", u[u.DOC_TYPE_START = 14] = "DOC_TYPE_START", u[u.DOC_TYPE_END = 15] = "DOC_TYPE_END", u[u.EXPANSION_FORM_START = 16] = "EXPANSION_FORM_START", u[u.EXPANSION_CASE_VALUE = 17] = "EXPANSION_CASE_VALUE", u[u.EXPANSION_CASE_EXP_START = 18] = "EXPANSION_CASE_EXP_START", u[u.EXPANSION_CASE_EXP_END = 19] = "EXPANSION_CASE_EXP_END", u[u.EXPANSION_FORM_END = 20] = "EXPANSION_FORM_END", u[u.EOF = 21] = "EOF";
        })(r = e.TokenType || (e.TokenType = {}));
        var i = class {
          constructor(u, n, A) {
            this.type = u, this.parts = n, this.sourceSpan = A;
          }
        };
        e.Token = i;
        var m = class extends a.ParseError {
          constructor(u, n, A) {
            super(A, u), this.tokenType = n;
          }
        };
        e.TokenError = m;
        var f = class {
          constructor(u, n) {
            this.tokens = u, this.errors = n;
          }
        };
        e.TokenizeResult = f;
        function L(u, n, A) {
          let C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
          return new F(new a.ParseSourceFile(u, n), A, C).tokenize();
        }
        e.tokenize = L;
        var s = /\r\n?/g;
        function D(u) {
          return `Unexpected character "${u === t.$EOF ? "EOF" : String.fromCharCode(u)}"`;
        }
        function E(u) {
          return `Unknown entity "${u}" - use the "&#<decimal>;" or  "&#x<hex>;" syntax`;
        }
        var v = class {
          constructor(u) {
            this.error = u;
          }
        }, F = class {
          constructor(u, n, A) {
            this._getTagContentType = n, this._currentTokenStart = null, this._currentTokenType = null, this._expansionCaseStack = [], this._inInterpolation = !1, this._fullNameStack = [], this.tokens = [], this.errors = [], this._tokenizeIcu = A.tokenizeExpansionForms || !1, this._interpolationConfig = A.interpolationConfig || o.DEFAULT_INTERPOLATION_CONFIG, this._leadingTriviaCodePoints = A.leadingTriviaChars && A.leadingTriviaChars.map((b) => b.codePointAt(0) || 0), this._canSelfClose = A.canSelfClose || !1, this._allowHtmComponentClosingTags = A.allowHtmComponentClosingTags || !1;
            let C = A.range || { endPos: u.content.length, startPos: 0, startLine: 0, startCol: 0 };
            this._cursor = A.escapedString ? new ee(u, C) : new Q(u, C);
            try {
              this._cursor.init();
            } catch (b) {
              this.handleError(b);
            }
          }
          _processCarriageReturns(u) {
            return u.replace(s, `
`);
          }
          tokenize() {
            for (; this._cursor.peek() !== t.$EOF; ) {
              let u = this._cursor.clone();
              try {
                if (this._attemptCharCode(t.$LT))
                  if (this._attemptCharCode(t.$BANG))
                    this._attemptStr("[CDATA[") ? this._consumeCdata(u) : this._attemptStr("--") ? this._consumeComment(u) : this._attemptStrCaseInsensitive("doctype") ? this._consumeDocType(u) : this._consumeBogusComment(u);
                  else if (this._attemptCharCode(t.$SLASH))
                    this._consumeTagClose(u);
                  else {
                    let n = this._cursor.clone();
                    this._attemptCharCode(t.$QUESTION) ? (this._cursor = n, this._consumeBogusComment(u)) : this._consumeTagOpen(u);
                  }
                else
                  this._tokenizeIcu && this._tokenizeExpansionForm() || this._consumeText();
              } catch (n) {
                this.handleError(n);
              }
            }
            return this._beginToken(r.EOF), this._endToken([]), new f(z(this.tokens), this.errors);
          }
          _tokenizeExpansionForm() {
            if (this.isExpansionFormStart())
              return this._consumeExpansionFormStart(), !0;
            if (W(this._cursor.peek()) && this._isInExpansionForm())
              return this._consumeExpansionCaseStart(), !0;
            if (this._cursor.peek() === t.$RBRACE) {
              if (this._isInExpansionCase())
                return this._consumeExpansionCaseEnd(), !0;
              if (this._isInExpansionForm())
                return this._consumeExpansionFormEnd(), !0;
            }
            return !1;
          }
          _beginToken(u) {
            let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
            this._currentTokenStart = n, this._currentTokenType = u;
          }
          _endToken(u) {
            let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
            if (this._currentTokenStart === null)
              throw new m("Programming error - attempted to end a token when there was no start to the token", this._currentTokenType, this._cursor.getSpan(n));
            if (this._currentTokenType === null)
              throw new m("Programming error - attempted to end a token which has no token type", null, this._cursor.getSpan(this._currentTokenStart));
            let A = new i(this._currentTokenType, u, this._cursor.getSpan(this._currentTokenStart, this._leadingTriviaCodePoints));
            return this.tokens.push(A), this._currentTokenStart = null, this._currentTokenType = null, A;
          }
          _createError(u, n) {
            this._isInExpansionForm() && (u += ` (Do you have an unescaped "{" in your template? Use "{{ '{' }}") to escape it.)`);
            let A = new m(u, this._currentTokenType, n);
            return this._currentTokenStart = null, this._currentTokenType = null, new v(A);
          }
          handleError(u) {
            if (u instanceof re && (u = this._createError(u.msg, this._cursor.getSpan(u.cursor))), u instanceof v)
              this.errors.push(u.error);
            else
              throw u;
          }
          _attemptCharCode(u) {
            return this._cursor.peek() === u ? (this._cursor.advance(), !0) : !1;
          }
          _attemptCharCodeCaseInsensitive(u) {
            return se(this._cursor.peek(), u) ? (this._cursor.advance(), !0) : !1;
          }
          _requireCharCode(u) {
            let n = this._cursor.clone();
            if (!this._attemptCharCode(u))
              throw this._createError(D(this._cursor.peek()), this._cursor.getSpan(n));
          }
          _attemptStr(u) {
            let n = u.length;
            if (this._cursor.charsLeft() < n)
              return !1;
            let A = this._cursor.clone();
            for (let C = 0; C < n; C++)
              if (!this._attemptCharCode(u.charCodeAt(C)))
                return this._cursor = A, !1;
            return !0;
          }
          _attemptStrCaseInsensitive(u) {
            for (let n = 0; n < u.length; n++)
              if (!this._attemptCharCodeCaseInsensitive(u.charCodeAt(n)))
                return !1;
            return !0;
          }
          _requireStr(u) {
            let n = this._cursor.clone();
            if (!this._attemptStr(u))
              throw this._createError(D(this._cursor.peek()), this._cursor.getSpan(n));
          }
          _requireStrCaseInsensitive(u) {
            let n = this._cursor.clone();
            if (!this._attemptStrCaseInsensitive(u))
              throw this._createError(D(this._cursor.peek()), this._cursor.getSpan(n));
          }
          _attemptCharCodeUntilFn(u) {
            for (; !u(this._cursor.peek()); )
              this._cursor.advance();
          }
          _requireCharCodeUntilFn(u, n) {
            let A = this._cursor.clone();
            if (this._attemptCharCodeUntilFn(u), this._cursor.clone().diff(A) < n)
              throw this._createError(D(this._cursor.peek()), this._cursor.getSpan(A));
          }
          _attemptUntilChar(u) {
            for (; this._cursor.peek() !== u; )
              this._cursor.advance();
          }
          _readChar(u) {
            if (u && this._cursor.peek() === t.$AMPERSAND)
              return this._decodeEntity();
            {
              let n = String.fromCodePoint(this._cursor.peek());
              return this._cursor.advance(), n;
            }
          }
          _decodeEntity() {
            let u = this._cursor.clone();
            if (this._cursor.advance(), this._attemptCharCode(t.$HASH)) {
              let n = this._attemptCharCode(t.$x) || this._attemptCharCode(t.$X), A = this._cursor.clone();
              if (this._attemptCharCodeUntilFn(O), this._cursor.peek() != t.$SEMICOLON)
                throw this._createError(D(this._cursor.peek()), this._cursor.getSpan());
              let C = this._cursor.getChars(A);
              this._cursor.advance();
              try {
                let b = parseInt(C, n ? 16 : 10);
                return String.fromCharCode(b);
              } catch {
                throw this._createError(E(this._cursor.getChars(u)), this._cursor.getSpan());
              }
            } else {
              let n = this._cursor.clone();
              if (this._attemptCharCodeUntilFn(G), this._cursor.peek() != t.$SEMICOLON)
                return this._cursor = n, "&";
              let A = this._cursor.getChars(n);
              this._cursor.advance();
              let C = p.NAMED_ENTITIES[A];
              if (!C)
                throw this._createError(E(A), this._cursor.getSpan(u));
              return C;
            }
          }
          _consumeRawText(u, n) {
            this._beginToken(u ? r.ESCAPABLE_RAW_TEXT : r.RAW_TEXT);
            let A = [];
            for (; ; ) {
              let C = this._cursor.clone(), b = n();
              if (this._cursor = C, b)
                break;
              A.push(this._readChar(u));
            }
            return this._endToken([this._processCarriageReturns(A.join(""))]);
          }
          _consumeComment(u) {
            this._beginToken(r.COMMENT_START, u), this._endToken([]), this._consumeRawText(!1, () => this._attemptStr("-->")), this._beginToken(r.COMMENT_END), this._requireStr("-->"), this._endToken([]);
          }
          _consumeBogusComment(u) {
            this._beginToken(r.COMMENT_START, u), this._endToken([]), this._consumeRawText(!1, () => this._cursor.peek() === t.$GT), this._beginToken(r.COMMENT_END), this._cursor.advance(), this._endToken([]);
          }
          _consumeCdata(u) {
            this._beginToken(r.CDATA_START, u), this._endToken([]), this._consumeRawText(!1, () => this._attemptStr("]]>")), this._beginToken(r.CDATA_END), this._requireStr("]]>"), this._endToken([]);
          }
          _consumeDocType(u) {
            this._beginToken(r.DOC_TYPE_START, u), this._endToken([]), this._consumeRawText(!1, () => this._cursor.peek() === t.$GT), this._beginToken(r.DOC_TYPE_END), this._cursor.advance(), this._endToken([]);
          }
          _consumePrefixAndName() {
            let u = this._cursor.clone(), n = "";
            for (; this._cursor.peek() !== t.$COLON && !X(this._cursor.peek()); )
              this._cursor.advance();
            let A;
            this._cursor.peek() === t.$COLON ? (n = this._cursor.getChars(u), this._cursor.advance(), A = this._cursor.clone()) : A = u, this._requireCharCodeUntilFn($, n === "" ? 0 : 1);
            let C = this._cursor.getChars(A);
            return [n, C];
          }
          _consumeTagOpen(u) {
            let n, A, C, b = this.tokens.length, K = this._cursor.clone(), te = [];
            try {
              if (!t.isAsciiLetter(this._cursor.peek()))
                throw this._createError(D(this._cursor.peek()), this._cursor.getSpan(u));
              for (C = this._consumeTagOpenStart(u), A = C.parts[0], n = C.parts[1], this._attemptCharCodeUntilFn(T); this._cursor.peek() !== t.$SLASH && this._cursor.peek() !== t.$GT; ) {
                let [oe, he] = this._consumeAttributeName();
                if (this._attemptCharCodeUntilFn(T), this._attemptCharCode(t.$EQ)) {
                  this._attemptCharCodeUntilFn(T);
                  let de = this._consumeAttributeValue();
                  te.push({ prefix: oe, name: he, value: de });
                } else
                  te.push({ prefix: oe, name: he });
                this._attemptCharCodeUntilFn(T);
              }
              this._consumeTagOpenEnd();
            } catch (oe) {
              if (oe instanceof v) {
                this._cursor = K, C && (this.tokens.length = b), this._beginToken(r.TEXT, u), this._endToken(["<"]);
                return;
              }
              throw oe;
            }
            if (this._canSelfClose && this.tokens[this.tokens.length - 1].type === r.TAG_OPEN_END_VOID)
              return;
            let le = this._getTagContentType(n, A, this._fullNameStack.length > 0, te);
            this._handleFullNameStackForTagOpen(A, n), le === p.TagContentType.RAW_TEXT ? this._consumeRawTextWithTagClose(A, n, !1) : le === p.TagContentType.ESCAPABLE_RAW_TEXT && this._consumeRawTextWithTagClose(A, n, !0);
          }
          _consumeRawTextWithTagClose(u, n, A) {
            this._consumeRawText(A, () => !this._attemptCharCode(t.$LT) || !this._attemptCharCode(t.$SLASH) || (this._attemptCharCodeUntilFn(T), !this._attemptStrCaseInsensitive(u ? `${u}:${n}` : n)) ? !1 : (this._attemptCharCodeUntilFn(T), this._attemptCharCode(t.$GT))), this._beginToken(r.TAG_CLOSE), this._requireCharCodeUntilFn((C) => C === t.$GT, 3), this._cursor.advance(), this._endToken([u, n]), this._handleFullNameStackForTagClose(u, n);
          }
          _consumeTagOpenStart(u) {
            this._beginToken(r.TAG_OPEN_START, u);
            let n = this._consumePrefixAndName();
            return this._endToken(n);
          }
          _consumeAttributeName() {
            let u = this._cursor.peek();
            if (u === t.$SQ || u === t.$DQ)
              throw this._createError(D(u), this._cursor.getSpan());
            this._beginToken(r.ATTR_NAME);
            let n = this._consumePrefixAndName();
            return this._endToken(n), n;
          }
          _consumeAttributeValue() {
            let u;
            if (this._cursor.peek() === t.$SQ || this._cursor.peek() === t.$DQ) {
              this._beginToken(r.ATTR_QUOTE);
              let n = this._cursor.peek();
              this._cursor.advance(), this._endToken([String.fromCodePoint(n)]), this._beginToken(r.ATTR_VALUE);
              let A = [];
              for (; this._cursor.peek() !== n; )
                A.push(this._readChar(!0));
              u = this._processCarriageReturns(A.join("")), this._endToken([u]), this._beginToken(r.ATTR_QUOTE), this._cursor.advance(), this._endToken([String.fromCodePoint(n)]);
            } else {
              this._beginToken(r.ATTR_VALUE);
              let n = this._cursor.clone();
              this._requireCharCodeUntilFn($, 1), u = this._processCarriageReturns(this._cursor.getChars(n)), this._endToken([u]);
            }
            return u;
          }
          _consumeTagOpenEnd() {
            let u = this._attemptCharCode(t.$SLASH) ? r.TAG_OPEN_END_VOID : r.TAG_OPEN_END;
            this._beginToken(u), this._requireCharCode(t.$GT), this._endToken([]);
          }
          _consumeTagClose(u) {
            if (this._beginToken(r.TAG_CLOSE, u), this._attemptCharCodeUntilFn(T), this._allowHtmComponentClosingTags && this._attemptCharCode(t.$SLASH))
              this._attemptCharCodeUntilFn(T), this._requireCharCode(t.$GT), this._endToken([]);
            else {
              let [n, A] = this._consumePrefixAndName();
              this._attemptCharCodeUntilFn(T), this._requireCharCode(t.$GT), this._endToken([n, A]), this._handleFullNameStackForTagClose(n, A);
            }
          }
          _consumeExpansionFormStart() {
            this._beginToken(r.EXPANSION_FORM_START), this._requireCharCode(t.$LBRACE), this._endToken([]), this._expansionCaseStack.push(r.EXPANSION_FORM_START), this._beginToken(r.RAW_TEXT);
            let u = this._readUntil(t.$COMMA);
            this._endToken([u]), this._requireCharCode(t.$COMMA), this._attemptCharCodeUntilFn(T), this._beginToken(r.RAW_TEXT);
            let n = this._readUntil(t.$COMMA);
            this._endToken([n]), this._requireCharCode(t.$COMMA), this._attemptCharCodeUntilFn(T);
          }
          _consumeExpansionCaseStart() {
            this._beginToken(r.EXPANSION_CASE_VALUE);
            let u = this._readUntil(t.$LBRACE).trim();
            this._endToken([u]), this._attemptCharCodeUntilFn(T), this._beginToken(r.EXPANSION_CASE_EXP_START), this._requireCharCode(t.$LBRACE), this._endToken([]), this._attemptCharCodeUntilFn(T), this._expansionCaseStack.push(r.EXPANSION_CASE_EXP_START);
          }
          _consumeExpansionCaseEnd() {
            this._beginToken(r.EXPANSION_CASE_EXP_END), this._requireCharCode(t.$RBRACE), this._endToken([]), this._attemptCharCodeUntilFn(T), this._expansionCaseStack.pop();
          }
          _consumeExpansionFormEnd() {
            this._beginToken(r.EXPANSION_FORM_END), this._requireCharCode(t.$RBRACE), this._endToken([]), this._expansionCaseStack.pop();
          }
          _consumeText() {
            let u = this._cursor.clone();
            this._beginToken(r.TEXT, u);
            let n = [];
            do
              this._interpolationConfig && this._attemptStr(this._interpolationConfig.start) ? (n.push(this._interpolationConfig.start), this._inInterpolation = !0) : this._interpolationConfig && this._inInterpolation && this._attemptStr(this._interpolationConfig.end) ? (n.push(this._interpolationConfig.end), this._inInterpolation = !1) : n.push(this._readChar(!0));
            while (!this._isTextEnd());
            this._endToken([this._processCarriageReturns(n.join(""))]);
          }
          _isTextEnd() {
            return !!(this._cursor.peek() === t.$LT || this._cursor.peek() === t.$EOF || this._tokenizeIcu && !this._inInterpolation && (this.isExpansionFormStart() || this._cursor.peek() === t.$RBRACE && this._isInExpansionCase()));
          }
          _readUntil(u) {
            let n = this._cursor.clone();
            return this._attemptUntilChar(u), this._cursor.getChars(n);
          }
          _isInExpansionCase() {
            return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === r.EXPANSION_CASE_EXP_START;
          }
          _isInExpansionForm() {
            return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === r.EXPANSION_FORM_START;
          }
          isExpansionFormStart() {
            if (this._cursor.peek() !== t.$LBRACE)
              return !1;
            if (this._interpolationConfig) {
              let u = this._cursor.clone(), n = this._attemptStr(this._interpolationConfig.start);
              return this._cursor = u, !n;
            }
            return !0;
          }
          _handleFullNameStackForTagOpen(u, n) {
            let A = p.mergeNsAndName(u, n);
            (this._fullNameStack.length === 0 || this._fullNameStack[this._fullNameStack.length - 1] === A) && this._fullNameStack.push(A);
          }
          _handleFullNameStackForTagClose(u, n) {
            let A = p.mergeNsAndName(u, n);
            this._fullNameStack.length !== 0 && this._fullNameStack[this._fullNameStack.length - 1] === A && this._fullNameStack.pop();
          }
        };
        function T(u) {
          return !t.isWhitespace(u) || u === t.$EOF;
        }
        function $(u) {
          return t.isWhitespace(u) || u === t.$GT || u === t.$SLASH || u === t.$SQ || u === t.$DQ || u === t.$EQ;
        }
        function X(u) {
          return (u < t.$a || t.$z < u) && (u < t.$A || t.$Z < u) && (u < t.$0 || u > t.$9);
        }
        function O(u) {
          return u == t.$SEMICOLON || u == t.$EOF || !t.isAsciiHexDigit(u);
        }
        function G(u) {
          return u == t.$SEMICOLON || u == t.$EOF || !t.isAsciiLetter(u);
        }
        function W(u) {
          return u === t.$EQ || t.isAsciiLetter(u) || t.isDigit(u);
        }
        function se(u, n) {
          return B(u) == B(n);
        }
        function B(u) {
          return u >= t.$a && u <= t.$z ? u - t.$a + t.$A : u;
        }
        function z(u) {
          let n = [], A;
          for (let C = 0; C < u.length; C++) {
            let b = u[C];
            A && A.type == r.TEXT && b.type == r.TEXT ? (A.parts[0] += b.parts[0], A.sourceSpan.end = b.sourceSpan.end) : (A = b, n.push(A));
          }
          return n;
        }
        var Q = class {
          constructor(u, n) {
            if (u instanceof Q)
              this.file = u.file, this.input = u.input, this.end = u.end, this.state = Object.assign({}, u.state);
            else {
              if (!n)
                throw new Error("Programming error: the range argument must be provided with a file argument.");
              this.file = u, this.input = u.content, this.end = n.endPos, this.state = { peek: -1, offset: n.startPos, line: n.startLine, column: n.startCol };
            }
          }
          clone() {
            return new Q(this);
          }
          peek() {
            return this.state.peek;
          }
          charsLeft() {
            return this.end - this.state.offset;
          }
          diff(u) {
            return this.state.offset - u.state.offset;
          }
          advance() {
            this.advanceState(this.state);
          }
          init() {
            this.updatePeek(this.state);
          }
          getSpan(u, n) {
            if (u = u || this, n)
              for (u = u.clone(); this.diff(u) > 0 && n.indexOf(u.peek()) !== -1; )
                u.advance();
            return new a.ParseSourceSpan(new a.ParseLocation(u.file, u.state.offset, u.state.line, u.state.column), new a.ParseLocation(this.file, this.state.offset, this.state.line, this.state.column));
          }
          getChars(u) {
            return this.input.substring(u.state.offset, this.state.offset);
          }
          charAt(u) {
            return this.input.charCodeAt(u);
          }
          advanceState(u) {
            if (u.offset >= this.end)
              throw this.state = u, new re('Unexpected character "EOF"', this);
            let n = this.charAt(u.offset);
            n === t.$LF ? (u.line++, u.column = 0) : t.isNewLine(n) || u.column++, u.offset++, this.updatePeek(u);
          }
          updatePeek(u) {
            u.peek = u.offset >= this.end ? t.$EOF : this.charAt(u.offset);
          }
        }, ee = class extends Q {
          constructor(u, n) {
            u instanceof ee ? (super(u), this.internalState = Object.assign({}, u.internalState)) : (super(u, n), this.internalState = this.state);
          }
          advance() {
            this.state = this.internalState, super.advance(), this.processEscapeSequence();
          }
          init() {
            super.init(), this.processEscapeSequence();
          }
          clone() {
            return new ee(this);
          }
          getChars(u) {
            let n = u.clone(), A = "";
            for (; n.internalState.offset < this.internalState.offset; )
              A += String.fromCodePoint(n.peek()), n.advance();
            return A;
          }
          processEscapeSequence() {
            let u = () => this.internalState.peek;
            if (u() === t.$BACKSLASH)
              if (this.internalState = Object.assign({}, this.state), this.advanceState(this.internalState), u() === t.$n)
                this.state.peek = t.$LF;
              else if (u() === t.$r)
                this.state.peek = t.$CR;
              else if (u() === t.$v)
                this.state.peek = t.$VTAB;
              else if (u() === t.$t)
                this.state.peek = t.$TAB;
              else if (u() === t.$b)
                this.state.peek = t.$BSPACE;
              else if (u() === t.$f)
                this.state.peek = t.$FF;
              else if (u() === t.$u)
                if (this.advanceState(this.internalState), u() === t.$LBRACE) {
                  this.advanceState(this.internalState);
                  let n = this.clone(), A = 0;
                  for (; u() !== t.$RBRACE; )
                    this.advanceState(this.internalState), A++;
                  this.state.peek = this.decodeHexDigits(n, A);
                } else {
                  let n = this.clone();
                  this.advanceState(this.internalState), this.advanceState(this.internalState), this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(n, 4);
                }
              else if (u() === t.$x) {
                this.advanceState(this.internalState);
                let n = this.clone();
                this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(n, 2);
              } else if (t.isOctalDigit(u())) {
                let n = "", A = 0, C = this.clone();
                for (; t.isOctalDigit(u()) && A < 3; )
                  C = this.clone(), n += String.fromCodePoint(u()), this.advanceState(this.internalState), A++;
                this.state.peek = parseInt(n, 8), this.internalState = C.internalState;
              } else
                t.isNewLine(this.internalState.peek) ? (this.advanceState(this.internalState), this.state = this.internalState) : this.state.peek = this.internalState.peek;
          }
          decodeHexDigits(u, n) {
            let A = this.input.substr(u.internalState.offset, n), C = parseInt(A, 16);
            if (isNaN(C))
              throw u.state = u.internalState, new re("Invalid hexadecimal escape sequence", u);
            return C;
          }
        }, re = class {
          constructor(u, n) {
            this.msg = u, this.cursor = n;
          }
        };
        e.CursorError = re;
      } }), ju = S({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/parser.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = _e(), a = Mu(), o = vr(), p = Qe(), r = class extends t.ParseError {
          constructor(s, D, E) {
            super(D, E), this.elementName = s;
          }
          static create(s, D, E) {
            return new r(s, D, E);
          }
        };
        e.TreeError = r;
        var i = class {
          constructor(s, D) {
            this.rootNodes = s, this.errors = D;
          }
        };
        e.ParseTreeResult = i;
        var m = class {
          constructor(s) {
            this.getTagDefinition = s;
          }
          parse(s, D, E) {
            let v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, F = arguments.length > 4 ? arguments[4] : void 0, T = (Q) => function(ee) {
              for (var re = arguments.length, u = new Array(re > 1 ? re - 1 : 0), n = 1; n < re; n++)
                u[n - 1] = arguments[n];
              return Q(ee.toLowerCase(), ...u);
            }, $ = v ? this.getTagDefinition : T(this.getTagDefinition), X = (Q) => $(Q).contentType, O = v ? F : T(F), G = F ? (Q, ee, re, u) => {
              let n = O(Q, ee, re, u);
              return n !== void 0 ? n : X(Q);
            } : X, W = o.tokenize(s, D, G, E), se = E && E.canSelfClose || !1, B = E && E.allowHtmComponentClosingTags || !1, z = new f(W.tokens, $, se, B, v).build();
            return new i(z.rootNodes, W.errors.concat(z.errors));
          }
        };
        e.Parser = m;
        var f = class {
          constructor(s, D, E, v, F) {
            this.tokens = s, this.getTagDefinition = D, this.canSelfClose = E, this.allowHtmComponentClosingTags = v, this.isTagNameCaseSensitive = F, this._index = -1, this._rootNodes = [], this._errors = [], this._elementStack = [], this._advance();
          }
          build() {
            for (; this._peek.type !== o.TokenType.EOF; )
              this._peek.type === o.TokenType.TAG_OPEN_START ? this._consumeStartTag(this._advance()) : this._peek.type === o.TokenType.TAG_CLOSE ? (this._closeVoidElement(), this._consumeEndTag(this._advance())) : this._peek.type === o.TokenType.CDATA_START ? (this._closeVoidElement(), this._consumeCdata(this._advance())) : this._peek.type === o.TokenType.COMMENT_START ? (this._closeVoidElement(), this._consumeComment(this._advance())) : this._peek.type === o.TokenType.TEXT || this._peek.type === o.TokenType.RAW_TEXT || this._peek.type === o.TokenType.ESCAPABLE_RAW_TEXT ? (this._closeVoidElement(), this._consumeText(this._advance())) : this._peek.type === o.TokenType.EXPANSION_FORM_START ? this._consumeExpansion(this._advance()) : this._peek.type === o.TokenType.DOC_TYPE_START ? this._consumeDocType(this._advance()) : this._advance();
            return new i(this._rootNodes, this._errors);
          }
          _advance() {
            let s = this._peek;
            return this._index < this.tokens.length - 1 && this._index++, this._peek = this.tokens[this._index], s;
          }
          _advanceIf(s) {
            return this._peek.type === s ? this._advance() : null;
          }
          _consumeCdata(s) {
            let D = this._advance(), E = this._getText(D), v = this._advanceIf(o.TokenType.CDATA_END);
            this._addToParent(new a.CDATA(E, new t.ParseSourceSpan(s.sourceSpan.start, (v || D).sourceSpan.end)));
          }
          _consumeComment(s) {
            let D = this._advanceIf(o.TokenType.RAW_TEXT), E = this._advanceIf(o.TokenType.COMMENT_END), v = D != null ? D.parts[0].trim() : null, F = new t.ParseSourceSpan(s.sourceSpan.start, (E || D || s).sourceSpan.end);
            this._addToParent(new a.Comment(v, F));
          }
          _consumeDocType(s) {
            let D = this._advanceIf(o.TokenType.RAW_TEXT), E = this._advanceIf(o.TokenType.DOC_TYPE_END), v = D != null ? D.parts[0].trim() : null, F = new t.ParseSourceSpan(s.sourceSpan.start, (E || D || s).sourceSpan.end);
            this._addToParent(new a.DocType(v, F));
          }
          _consumeExpansion(s) {
            let D = this._advance(), E = this._advance(), v = [];
            for (; this._peek.type === o.TokenType.EXPANSION_CASE_VALUE; ) {
              let T = this._parseExpansionCase();
              if (!T)
                return;
              v.push(T);
            }
            if (this._peek.type !== o.TokenType.EXPANSION_FORM_END) {
              this._errors.push(r.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
              return;
            }
            let F = new t.ParseSourceSpan(s.sourceSpan.start, this._peek.sourceSpan.end);
            this._addToParent(new a.Expansion(D.parts[0], E.parts[0], v, F, D.sourceSpan)), this._advance();
          }
          _parseExpansionCase() {
            let s = this._advance();
            if (this._peek.type !== o.TokenType.EXPANSION_CASE_EXP_START)
              return this._errors.push(r.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'.")), null;
            let D = this._advance(), E = this._collectExpansionExpTokens(D);
            if (!E)
              return null;
            let v = this._advance();
            E.push(new o.Token(o.TokenType.EOF, [], v.sourceSpan));
            let F = new f(E, this.getTagDefinition, this.canSelfClose, this.allowHtmComponentClosingTags, this.isTagNameCaseSensitive).build();
            if (F.errors.length > 0)
              return this._errors = this._errors.concat(F.errors), null;
            let T = new t.ParseSourceSpan(s.sourceSpan.start, v.sourceSpan.end), $ = new t.ParseSourceSpan(D.sourceSpan.start, v.sourceSpan.end);
            return new a.ExpansionCase(s.parts[0], F.rootNodes, T, s.sourceSpan, $);
          }
          _collectExpansionExpTokens(s) {
            let D = [], E = [o.TokenType.EXPANSION_CASE_EXP_START];
            for (; ; ) {
              if ((this._peek.type === o.TokenType.EXPANSION_FORM_START || this._peek.type === o.TokenType.EXPANSION_CASE_EXP_START) && E.push(this._peek.type), this._peek.type === o.TokenType.EXPANSION_CASE_EXP_END)
                if (L(E, o.TokenType.EXPANSION_CASE_EXP_START)) {
                  if (E.pop(), E.length == 0)
                    return D;
                } else
                  return this._errors.push(r.create(null, s.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              if (this._peek.type === o.TokenType.EXPANSION_FORM_END)
                if (L(E, o.TokenType.EXPANSION_FORM_START))
                  E.pop();
                else
                  return this._errors.push(r.create(null, s.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              if (this._peek.type === o.TokenType.EOF)
                return this._errors.push(r.create(null, s.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              D.push(this._advance());
            }
          }
          _getText(s) {
            let D = s.parts[0];
            if (D.length > 0 && D[0] == `
`) {
              let E = this._getParentElement();
              E != null && E.children.length == 0 && this.getTagDefinition(E.name).ignoreFirstLf && (D = D.substring(1));
            }
            return D;
          }
          _consumeText(s) {
            let D = this._getText(s);
            D.length > 0 && this._addToParent(new a.Text(D, s.sourceSpan));
          }
          _closeVoidElement() {
            let s = this._getParentElement();
            s && this.getTagDefinition(s.name).isVoid && this._elementStack.pop();
          }
          _consumeStartTag(s) {
            let D = s.parts[0], E = s.parts[1], v = [];
            for (; this._peek.type === o.TokenType.ATTR_NAME; )
              v.push(this._consumeAttr(this._advance()));
            let F = this._getElementFullName(D, E, this._getParentElement()), T = !1;
            if (this._peek.type === o.TokenType.TAG_OPEN_END_VOID) {
              this._advance(), T = !0;
              let W = this.getTagDefinition(F);
              this.canSelfClose || W.canSelfClose || p.getNsPrefix(F) !== null || W.isVoid || this._errors.push(r.create(F, s.sourceSpan, `Only void and foreign elements can be self closed "${s.parts[1]}"`));
            } else
              this._peek.type === o.TokenType.TAG_OPEN_END && (this._advance(), T = !1);
            let $ = this._peek.sourceSpan.start, X = new t.ParseSourceSpan(s.sourceSpan.start, $), O = new t.ParseSourceSpan(s.sourceSpan.start.moveBy(1), s.sourceSpan.end), G = new a.Element(F, v, [], X, X, void 0, O);
            this._pushElement(G), T && (this._popElement(F), G.endSourceSpan = X);
          }
          _pushElement(s) {
            let D = this._getParentElement();
            D && this.getTagDefinition(D.name).isClosedByChild(s.name) && this._elementStack.pop(), this._addToParent(s), this._elementStack.push(s);
          }
          _consumeEndTag(s) {
            let D = this.allowHtmComponentClosingTags && s.parts.length === 0 ? null : this._getElementFullName(s.parts[0], s.parts[1], this._getParentElement());
            if (this._getParentElement() && (this._getParentElement().endSourceSpan = s.sourceSpan), D && this.getTagDefinition(D).isVoid)
              this._errors.push(r.create(D, s.sourceSpan, `Void elements do not have end tags "${s.parts[1]}"`));
            else if (!this._popElement(D)) {
              let E = `Unexpected closing tag "${D}". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags`;
              this._errors.push(r.create(D, s.sourceSpan, E));
            }
          }
          _popElement(s) {
            for (let D = this._elementStack.length - 1; D >= 0; D--) {
              let E = this._elementStack[D];
              if (!s || (p.getNsPrefix(E.name) ? E.name == s : E.name.toLowerCase() == s.toLowerCase()))
                return this._elementStack.splice(D, this._elementStack.length - D), !0;
              if (!this.getTagDefinition(E.name).closedByParent)
                return !1;
            }
            return !1;
          }
          _consumeAttr(s) {
            let D = p.mergeNsAndName(s.parts[0], s.parts[1]), E = s.sourceSpan.end, v = "", F, T;
            if (this._peek.type === o.TokenType.ATTR_QUOTE && (T = this._advance().sourceSpan.start), this._peek.type === o.TokenType.ATTR_VALUE) {
              let $ = this._advance();
              v = $.parts[0], E = $.sourceSpan.end, F = $.sourceSpan;
            }
            return this._peek.type === o.TokenType.ATTR_QUOTE && (E = this._advance().sourceSpan.end, F = new t.ParseSourceSpan(T, E)), new a.Attribute(D, v, new t.ParseSourceSpan(s.sourceSpan.start, E), F, s.sourceSpan);
          }
          _getParentElement() {
            return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
          }
          _getParentElementSkippingContainers() {
            let s = null;
            for (let D = this._elementStack.length - 1; D >= 0; D--) {
              if (!p.isNgContainer(this._elementStack[D].name))
                return { parent: this._elementStack[D], container: s };
              s = this._elementStack[D];
            }
            return { parent: null, container: s };
          }
          _addToParent(s) {
            let D = this._getParentElement();
            D != null ? D.children.push(s) : this._rootNodes.push(s);
          }
          _insertBeforeContainer(s, D, E) {
            if (!D)
              this._addToParent(E), this._elementStack.push(E);
            else {
              if (s) {
                let v = s.children.indexOf(D);
                s.children[v] = E;
              } else
                this._rootNodes.push(E);
              E.children.push(D), this._elementStack.splice(this._elementStack.indexOf(D), 0, E);
            }
          }
          _getElementFullName(s, D, E) {
            return s === "" && (s = this.getTagDefinition(D).implicitNamespacePrefix || "", s === "" && E != null && (s = p.getNsPrefix(E.name))), p.mergeNsAndName(s, D);
          }
        };
        function L(s, D) {
          return s.length > 0 && s[s.length - 1] === D;
        }
      } }), Tr = S({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_parser.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = qu(), a = ju(), o = ju();
        e.ParseTreeResult = o.ParseTreeResult, e.TreeError = o.TreeError;
        var p = class extends a.Parser {
          constructor() {
            super(t.getHtmlTagDefinition);
          }
          parse(r, i, m) {
            let f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, L = arguments.length > 4 ? arguments[4] : void 0;
            return super.parse(r, i, m, f, L);
          }
        };
        e.HtmlParser = p;
      } }), Uu = S({ "node_modules/angular-html-parser/lib/angular-html-parser/src/index.js"(e) {
        R(), Object.defineProperty(e, "__esModule", { value: !0 });
        var t = Tr(), a = Qe();
        e.TagContentType = a.TagContentType;
        var o = null, p = () => (o || (o = new t.HtmlParser()), o);
        function r(i) {
          let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { canSelfClose: f = !1, allowHtmComponentClosingTags: L = !1, isTagNameCaseSensitive: s = !1, getTagContentType: D } = m;
          return p().parse(i, "angular-html-parser", { tokenizeExpansionForms: !1, interpolationConfig: void 0, canSelfClose: f, allowHtmComponentClosingTags: L }, s, D);
        }
        e.parse = r;
      } });
      R();
      var { ParseSourceSpan: Ye, ParseLocation: Vu, ParseSourceFile: _r } = _e(), Sr = Se(), yr = ke(), Br = Ie(), { inferParserByLanguage: br } = or(), wr = lr(), pu = hr(), Gu = dr(), { hasPragma: xr } = Cr(), { Node: Nr } = Er(), { parseIeConditionalComment: kr } = mr(), { locStart: Or, locEnd: Pr } = fr();
      function Rr(e, t, a) {
        let { canSelfClose: o, normalizeTagName: p, normalizeAttributeName: r, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: m, getTagContentType: f } = t, L = Uu(), { RecursiveVisitor: s, visitAll: D } = Mu(), { ParseSourceSpan: E } = _e(), { getHtmlTagDefinition: v } = qu(), { rootNodes: F, errors: T } = L.parse(e, { canSelfClose: o, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: m, getTagContentType: f });
        if (a.parser === "vue")
          if (F.some((B) => B.type === "docType" && B.value === "html" || B.type === "element" && B.name.toLowerCase() === "html")) {
            o = !0, p = !0, r = !0, i = !0, m = !1;
            let B = L.parse(e, { canSelfClose: o, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: m });
            F = B.rootNodes, T = B.errors;
          } else {
            let B = (z) => {
              if (!z || z.type !== "element" || z.name !== "template")
                return !1;
              let Q = z.attrs.find((re) => re.name === "lang"), ee = Q && Q.value;
              return !ee || br(ee, a) === "html";
            };
            if (F.some(B)) {
              let z, Q = () => L.parse(e, { canSelfClose: o, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: m }), ee = () => z || (z = Q()), re = (u) => ee().rootNodes.find((n) => {
                let { startSourceSpan: A } = n;
                return A && A.start.offset === u.startSourceSpan.start.offset;
              });
              for (let u = 0; u < F.length; u++) {
                let n = F[u], { endSourceSpan: A, startSourceSpan: C } = n;
                if (A === null)
                  T = ee().errors, F[u] = re(n) || n;
                else if (B(n)) {
                  let b = ee(), K = C.end.offset, te = A.start.offset;
                  for (let le of b.errors) {
                    let { offset: oe } = le.span.start;
                    if (K < oe && oe < te) {
                      T = [le];
                      break;
                    }
                  }
                  F[u] = re(n) || n;
                }
              }
            }
          }
        if (T.length > 0) {
          let { msg: B, span: { start: z, end: Q } } = T[0];
          throw Br(B, { start: { line: z.line + 1, column: z.col + 1 }, end: { line: Q.line + 1, column: Q.col + 1 } });
        }
        let $ = (B) => {
          let z = B.name.startsWith(":") ? B.name.slice(1).split(":")[0] : null, Q = B.nameSpan.toString(), ee = z !== null && Q.startsWith(`${z}:`), re = ee ? Q.slice(z.length + 1) : Q;
          B.name = re, B.namespace = z, B.hasExplicitNamespace = ee;
        }, X = (B) => {
          switch (B.type) {
            case "element":
              $(B);
              for (let z of B.attrs)
                $(z), z.valueSpan ? (z.value = z.valueSpan.toString(), /["']/.test(z.value[0]) && (z.value = z.value.slice(1, -1))) : z.value = null;
              break;
            case "comment":
              B.value = B.sourceSpan.toString().slice(4, -3);
              break;
            case "text":
              B.value = B.sourceSpan.toString();
              break;
          }
        }, O = (B, z) => {
          let Q = B.toLowerCase();
          return z(Q) ? Q : B;
        }, G = (B) => {
          if (B.type === "element" && (p && (!B.namespace || B.namespace === B.tagDefinition.implicitNamespacePrefix || Gu(B)) && (B.name = O(B.name, (z) => z in wr)), r)) {
            let z = pu[B.name] || /* @__PURE__ */ Object.create(null);
            for (let Q of B.attrs)
              Q.namespace || (Q.name = O(Q.name, (ee) => B.name in pu && (ee in pu["*"] || ee in z)));
          }
        }, W = (B) => {
          B.sourceSpan && B.endSourceSpan && (B.sourceSpan = new E(B.sourceSpan.start, B.endSourceSpan.end));
        }, se = (B) => {
          if (B.type === "element") {
            let z = v(m ? B.name : B.name.toLowerCase());
            !B.namespace || B.namespace === z.implicitNamespacePrefix || Gu(B) ? B.tagDefinition = z : B.tagDefinition = v("");
          }
        };
        return D(new class extends s {
          visit(B) {
            X(B), se(B), G(B), W(B);
          }
        }(), F), F;
      }
      function Xu(e, t, a) {
        let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, { frontMatter: p, content: r } = o ? Sr(e) : { frontMatter: null, content: e }, i = new _r(e, t.filepath), m = new Vu(i, 0, 0, 0), f = m.moveBy(e.length), L = { type: "root", sourceSpan: new Ye(m, f), children: Rr(r, a, t) };
        if (p) {
          let E = new Vu(i, 0, 0, 0), v = E.moveBy(p.raw.length);
          p.sourceSpan = new Ye(E, v), L.children.unshift(p);
        }
        let s = new Nr(L), D = (E, v) => {
          let { offset: F } = v, T = e.slice(0, F).replace(/[^\n\r]/g, " "), $ = Xu(T + E, t, a, !1);
          $.sourceSpan = new Ye(v, yr($.children).sourceSpan.end);
          let X = $.children[0];
          return X.length === F ? $.children.shift() : (X.sourceSpan = new Ye(X.sourceSpan.start.moveBy(F), X.sourceSpan.end), X.value = X.value.slice(F)), $;
        };
        return s.walk((E) => {
          if (E.type === "comment") {
            let v = kr(E, D);
            v && E.parent.replaceChild(E, v);
          }
        }), s;
      }
      function Je() {
        let { name: e, canSelfClose: t = !1, normalizeTagName: a = !1, normalizeAttributeName: o = !1, allowHtmComponentClosingTags: p = !1, isTagNameCaseSensitive: r = !1, getTagContentType: i } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return { parse: (m, f, L) => Xu(m, Object.assign({ parser: e }, L), { canSelfClose: t, normalizeTagName: a, normalizeAttributeName: o, allowHtmComponentClosingTags: p, isTagNameCaseSensitive: r, getTagContentType: i }), hasPragma: xr, astFormat: "html", locStart: Or, locEnd: Pr };
      }
      c.exports = { parsers: { html: Je({ name: "html", canSelfClose: !0, normalizeTagName: !0, normalizeAttributeName: !0, allowHtmComponentClosingTags: !0 }), angular: Je({ name: "angular", canSelfClose: !0 }), vue: Je({ name: "vue", canSelfClose: !0, isTagNameCaseSensitive: !0, getTagContentType: (e, t, a, o) => {
        if (e.toLowerCase() !== "html" && !a && (e !== "template" || o.some((p) => {
          let { name: r, value: i } = p;
          return r === "lang" && i !== "html" && i !== "" && i !== void 0;
        })))
          return Uu().TagContentType.RAW_TEXT;
      } }), lwc: Je({ name: "lwc" }) } };
    });
    return Mt();
  });
})(Yu);
var Lr = Yu.exports;
const jr = /* @__PURE__ */ Ir(Lr);
export {
  jr as default
};
